// This file is auto generated
export class PortalResources {
  public static azureFunctions = 'azureFunctions';
  public static azureFunctionsRuntime = 'azureFunctionsRuntime';
  public static cancel = 'cancel';
  public static apply = 'apply';
  public static configure = 'configure';
  public static upgrade = 'upgrade';
  public static upgradeToEnable = 'upgradeToEnable';
  public static selectAll = 'selectAll';
  public static allItemsSelected = 'allItemsSelected';
  public static numItemsSelected = 'numItemsSelected';
  public static cpu = 'cpu';
  public static memory = 'memory';
  public static storage = 'storage';
  public static function = 'function';
  public static functionCreateErrorDetails = 'functionCreateErrorDetails';
  public static functionCreateErrorMessage = 'functionCreateErrorMessage';
  public static creatingFunction = 'creatingFunction';
  public static functionDev_functionErrorDetails = 'functionDev_functionErrorDetails';
  public static functionDev_functionErrorMessage = 'functionDev_functionErrorMessage';
  public static functionDev_functionUrl = 'functionDev_functionUrl';
  public static functionDev_githubSelect = 'functionDev_githubSelect';
  public static functionDev_hideFiles = 'functionDev_hideFiles';
  public static functionDev_hostErrorMessage = 'functionDev_hostErrorMessage';
  public static functionDev_Output = 'functionDev_Output';
  public static functionDev_requestBody = 'functionDev_requestBody';
  public static functionDev_saveAndRun = 'functionDev_saveAndRun';
  public static functionDev_status = 'functionDev_status';
  public static functionDev_viewFiles = 'functionDev_viewFiles';
  public static functionNew_chooseTemplate = 'functionNew_chooseTemplate';
  public static subNew_subAlreadyExist = 'subNew_subAlreadyExist';
  public static subNew_chooseTemplate = 'subNew_chooseTemplate';
  public static subNew_nameYourFriendlySubName = 'subNew_nameYourFriendlySubName';
  public static subNew_friendlySubNameName = 'subNew_friendlySubNameName';
  public static subNew_invitationCode = 'subNew_invitationCode';
  public static functionNew_experimentalTemplate = 'functionNew_experimentalTemplate';
  public static functionNew_functionKind = 'functionNew_functionKind';
  public static functionNew_functionName = 'functionNew_functionName';
  public static functionNew_functionNameRequired = 'functionNew_functionNameRequired';
  public static functionNew_nameYourFunction = 'functionNew_nameYourFunction';
  public static gettingStarted_createGetStarted = 'gettingStarted_createGetStarted';
  public static gettingStarted_functionApps = 'gettingStarted_functionApps';
  public static gettingStarted_getStarted = 'gettingStarted_getStarted';
  public static gettingStarted_newFunctionApp = 'gettingStarted_newFunctionApp';
  public static gettingStarted_noFunApps = 'gettingStarted_noFunApps';
  public static gettingStarted_orCreate = 'gettingStarted_orCreate';
  public static gettingStarted_selectLocation = 'gettingStarted_selectLocation';
  public static gettingStarted_selectSubscription = 'gettingStarted_selectSubscription';
  public static gettingStarted_subIsNotWhitelisted = 'gettingStarted_subIsNotWhitelisted';
  public static gettingStarted_thisSub = 'gettingStarted_thisSub';
  public static gettingStarted_validateContainer1 = 'gettingStarted_validateContainer1';
  public static gettingStarted_validateContainer2 = 'gettingStarted_validateContainer2';
  public static gettingStarted_validateContainer3 = 'gettingStarted_validateContainer3';
  public static gettingStarted_validateContainer4 = 'gettingStarted_validateContainer4';
  public static gettingStarted_youNeed = 'gettingStarted_youNeed';
  public static gettingStarted_yourFunctionApps = 'gettingStarted_yourFunctionApps';
  public static gettingStarted_yourSubscription = 'gettingStarted_yourSubscription';
  public static createApp_description = 'createApp_description';
  public static createApp_fail = 'createApp_fail';
  public static intro_chooseLanguage = 'intro_chooseLanguage';
  public static intro_chooseScenario = 'intro_chooseScenario';
  public static intro_createThisFunction = 'intro_createThisFunction';
  public static intro_createYourOwn = 'intro_createYourOwn';
  public static intro_customFunction = 'intro_customFunction';
  public static intro_dataProcessing = 'intro_dataProcessing';
  public static intro_or = 'intro_or';
  public static intro_getStarted = 'intro_getStarted';
  public static intro_getStartedOn = 'intro_getStartedOn';
  public static intro_keepUsingQuickstart = 'intro_keepUsingQuickstart';
  public static intro_ifYou = 'intro_ifYou';
  public static intro_startSC = 'intro_startSC';
  public static intro_timer = 'intro_timer';
  public static intro_webHook = 'intro_webHook';
  public static logStreaming_clear = 'logStreaming_clear';
  public static logStreaming_copied = 'logStreaming_copied';
  public static logStreaming_copyLogs = 'logStreaming_copyLogs';
  public static logStreaming_noLogs = 'logStreaming_noLogs';
  public static logStreaming_failedToDownload = 'logStreaming_failedToDownload';
  public static logStreaming_pause = 'logStreaming_pause';
  public static logStreaming_paused = 'logStreaming_paused';
  public static logStreaming_start = 'logStreaming_start';
  public static logStreaming_tooManyLogs = 'logStreaming_tooManyLogs';
  public static logStreaming_reconnect = 'logStreaming_reconnect';
  public static logStreaming_reconnectSuccess = 'logStreaming_reconnectSuccess';
  public static logStreaming_connectionExists = 'logStreaming_connectionExists';
  public static _name = '_name';
  public static open = 'open';
  public static or = 'or';
  public static readOnlySourceControlled = 'readOnlySourceControlled';
  public static region = 'region';
  public static deletePreviousPlanMessage = 'deletePreviousPlanMessage';
  public static deletePreviousPlanCheckBoxText = 'deletePreviousPlanCheckBoxText';
  public static changeAppPlanInfoBox = 'changeAppPlanInfoBox';
  public static run = 'run';
  public static refresh = 'refresh';
  public static save = 'save';
  public static unsavedChangesWarning = 'unsavedChangesWarning';
  public static saveOperationInProgressWarning = 'saveOperationInProgressWarning';
  public static addNewSetting = 'addNewSetting';
  public static addNewConnectionString = 'addNewConnectionString';
  public static addNewDocument = 'addNewDocument';
  public static addNewHandlerMapping = 'addNewHandlerMapping';
  public static addNewVirtualDirectory = 'addNewVirtualDirectory';
  public static enterName = 'enterName';
  public static enterValue = 'enterValue';
  public static enterExtension = 'enterExtension';
  public static enterScriptProcessor = 'enterScriptProcessor';
  public static enterArguments = 'enterArguments';
  public static enterVirtualPath = 'enterVirtualPath';
  public static enterPhysicalPath = 'enterPhysicalPath';
  public static hiddenValueClickToShow = 'hiddenValueClickToShow';
  public static sideBar_changeMade = 'sideBar_changeMade';
  public static sideBar_newFunction = 'sideBar_newFunction';
  public static sideBar_refresh = 'sideBar_refresh';
  public static search = 'search';
  public static scopeToItem = 'scopeToItem';
  public static searchFeatures = 'searchFeatures';
  public static searchFunctionApps = 'searchFunctionApps';
  public static subscription = 'subscription';
  public static subscriptionName = 'subscriptionName';
  public static resourceGroup = 'resourceGroup';
  public static location = 'location';
  public static noResults = 'noResults';
  public static topBar_changeMade = 'topBar_changeMade';
  public static topBar_functionAppSettings = 'topBar_functionAppSettings';
  public static topBar_newVersion = 'topBar_newVersion';
  public static topBar_quickStart = 'topBar_quickStart';
  public static topBar_usage = 'topBar_usage';
  public static all = 'all';
  public static appMonitoring_appExecutions = 'appMonitoring_appExecutions';
  public static appMonitoring_appUsage = 'appMonitoring_appUsage';
  public static appMonitoring_functionAppUsage = 'appMonitoring_functionAppUsage';
  public static appMonitoring_noData = 'appMonitoring_noData';
  public static appMonitoring_ofExecutions = 'appMonitoring_ofExecutions';
  public static binding_parameterName = 'binding_parameterName';
  public static close = 'close';
  public static config = 'config';
  public static cors = 'cors';
  public static create = 'create';
  public static add = 'add';
  public static dashboard_yourTrialExpiered = 'dashboard_yourTrialExpiered';
  public static disabled = 'disabled';
  public static enabled = 'enabled';
  public static disable = 'disable';
  public static enable = 'enable';
  public static errorList_here = 'errorList_here';
  public static errorList_youMay = 'errorList_youMay';
  public static errorParsingConfig = 'errorParsingConfig';
  public static failedToSwitchFunctionState = 'failedToSwitchFunctionState';
  public static features = 'features';
  public static fieldRequired = 'fieldRequired';
  public static functionDev_code = 'functionDev_code';
  public static functionDev_run = 'functionDev_run';
  public static functionEdit_readOnly = 'functionEdit_readOnly';
  public static functionIntegrate_advancedEditor = 'functionIntegrate_advancedEditor';
  public static functionIntegrate_changesLost1 = 'functionIntegrate_changesLost1';
  public static functionIntegrate_changesLost2 = 'functionIntegrate_changesLost2';
  public static functionIntegrate_settingName = 'functionIntegrate_settingName';
  public static functionIntegrate_standardEditor = 'functionIntegrate_standardEditor';
  public static functionManage_delete = 'functionManage_delete';
  public static functionManage_areYouSure = 'functionManage_areYouSure';
  public static functionMonitor_loading = 'functionMonitor_loading';
  public static functionMonitor_successAggregate = 'functionMonitor_successAggregate';
  public static functionMonitor_errorsAggregate = 'functionMonitor_errorsAggregate';
  public static functionMonitor_invocationLog = 'functionMonitor_invocationLog';
  public static functionMonitor_invocationDetails = 'functionMonitor_invocationDetails';
  public static functionMonitor_invocationOutput = 'functionMonitor_invocationOutput';
  public static functionMonitor_pulseUrl = 'functionMonitor_pulseUrl';
  public static functionMonitorTable_functionColumn = 'functionMonitorTable_functionColumn';
  public static functionMonitorTable_statusColumn = 'functionMonitorTable_statusColumn';
  public static functionMonitorTable_detailsColumn = 'functionMonitorTable_detailsColumn';
  public static functionMonitorTable_durationColumn = 'functionMonitorTable_durationColumn';
  public static functionMonitorInvocationTable_paramColumn = 'functionMonitorInvocationTable_paramColumn';
  public static functionService_authIsEnabled = 'functionService_authIsEnabled';
  public static functionService_errorRunningFunc = 'functionService_errorRunningFunc';
  public static input = 'input';
  public static logStreaming_logs = 'logStreaming_logs';
  public static newInput = 'newInput';
  public static newOutput = 'newOutput';
  public static newTrigger = 'newTrigger';
  public static next = 'next';
  public static notValidValue = 'notValidValue';
  public static output = 'output';
  public static select = 'select';
  public static tabNames_develop = 'tabNames_develop';
  public static tabNames_integrate = 'tabNames_integrate';
  public static tabNames_manage = 'tabNames_manage';
  public static tabNames_monitor = 'tabNames_monitor';
  public static templatePicker_chooseInput = 'templatePicker_chooseInput';
  public static templatePicker_chooseOutput = 'templatePicker_chooseOutput';
  public static templatePicker_chooseTemplate = 'templatePicker_chooseTemplate';
  public static templatePicker_chooseTrigger = 'templatePicker_chooseTrigger';
  public static templatePicker_language = 'templatePicker_language';
  public static templatePicker_scenario = 'templatePicker_scenario';
  public static trigger = 'trigger';
  public static tryNow_trialExpired = 'tryNow_trialExpired';
  public static tutorial_changesMade = 'tutorial_changesMade';
  public static tutorial_createNew = 'tutorial_createNew';
  public static tutorial_develop = 'tutorial_develop';
  public static tutorial_diveIntoDocumentation = 'tutorial_diveIntoDocumentation';
  public static tutorial_functionAppSettings = 'tutorial_functionAppSettings';
  public static tutorial_integrate = 'tutorial_integrate';
  public static tutorial_integrateYourFunction = 'tutorial_integrateYourFunction';
  public static tutorial_nextSteps = 'tutorial_nextSteps';
  public static tutorial_setUpAutomated = 'tutorial_setUpAutomated';
  public static tutorial_skip = 'tutorial_skip';
  public static tutorial_theFastestWayNode = 'tutorial_theFastestWayNode';
  public static tutorial_thisPageInclude = 'tutorial_thisPageInclude';
  public static tutorial_tweakThisSample = 'tutorial_tweakThisSample';
  public static tutorial_yourFunction = 'tutorial_yourFunction';
  public static update = 'update';
  public static bindingInput_select = 'bindingInput_select';
  public static binding_delete = 'binding_delete';
  public static bindingsValidationDirectionMissed = 'bindingsValidationDirectionMissed';
  public static bindingsValidationDirectionUnknown = 'bindingsValidationDirectionUnknown';
  public static bindingsValidationNameDublicate = 'bindingsValidationNameDublicate';
  public static bindingsValidationNameMissed = 'bindingsValidationNameMissed';
  public static bindingsValidationTypeMIssed = 'bindingsValidationTypeMIssed';
  public static bindingsValidationTypeUnknown = 'bindingsValidationTypeUnknown';
  public static resourceSelect = 'resourceSelect';
  public static trialExpired_enjoyedHostingFunctions = 'trialExpired_enjoyedHostingFunctions';
  public static trialExpired_signupForAzure = 'trialExpired_signupForAzure';
  public static tryLanding_chooseAnAuthProvider = 'tryLanding_chooseAnAuthProvider';
  public static tryLanding_microsoftAcccount = 'tryLanding_microsoftAcccount';
  public static tryNow_createFreeAzureAccount = 'tryNow_createFreeAzureAccount';
  public static tryNow_extendTrial = 'tryNow_extendTrial';
  public static tryNow_trialTimeRemaining = 'tryNow_trialTimeRemaining';
  public static tryLanding_functionError = 'tryLanding_functionError';
  public static tryLanding_functionErrorDetails = 'tryLanding_functionErrorDetails';
  public static tryLanding_ifYou = 'tryLanding_ifYou';
  public static tryNow_minutes = 'tryNow_minutes';
  public static bindingInput_new = 'bindingInput_new';
  public static integrate_inputsHelp = 'integrate_inputsHelp';
  public static integrate_outputsHelp = 'integrate_outputsHelp';
  public static integrate_triggersHelp = 'integrate_triggersHelp';
  public static integrate_unknownCardTitle = 'integrate_unknownCardTitle';
  public static binding_createNewFunction = 'binding_createNewFunction';
  public static binding_documentation = 'binding_documentation';
  public static binding_go = 'binding_go';
  public static copypre_copied = 'copypre_copied';
  public static copypre_copyClipboard = 'copypre_copyClipboard';
  public static fileExplorer_changesLost = 'fileExplorer_changesLost';
  public static fileExplorer_deletePromt = 'fileExplorer_deletePromt';
  public static fileExplorer_editingBinary = 'fileExplorer_editingBinary';
  public static fileExplorer_errorCreatingFile = 'fileExplorer_errorCreatingFile';
  public static fileExplorer_errorDeletingFile = 'fileExplorer_errorDeletingFile';
  public static tutorial_theFastestWayCSharp = 'tutorial_theFastestWayCSharp';
  public static binding_actions = 'binding_actions';
  public static tryNow_lessThanOneMinute = 'tryNow_lessThanOneMinute';
  public static tryNow_FreeAccountToolTip = 'tryNow_FreeAccountToolTip';
  public static error_CORSNotConfigured = 'error_CORSNotConfigured';
  public static error_DnsResolution = 'error_DnsResolution';
  public static error_UnableToRetrieveFunctionApp = 'error_UnableToRetrieveFunctionApp';
  public static error_UnableToRetrieveFunctions = 'error_UnableToRetrieveFunctions';
  public static tryNow_fewMoreSeconds = 'tryNow_fewMoreSeconds';
  public static tryNow_hangOn = 'tryNow_hangOn';
  public static tryNow_discoverMore = 'tryNow_discoverMore';
  public static fileExplorer_add = 'fileExplorer_add';
  public static fileExplorer_delete = 'fileExplorer_delete';
  public static fileExplorer_edit = 'fileExplorer_edit';
  public static fileExplorer_upload = 'fileExplorer_upload';
  public static upload = 'upload';
  public static seeAllOptions = 'seeAllOptions';
  public static seeRecommendedOptions = 'seeRecommendedOptions';
  public static storageLockNote = 'storageLockNote';
  public static fileExplorer_fileAlreadyExists = 'fileExplorer_fileAlreadyExists';
  public static functionNew_fileExists = 'functionNew_fileExists';
  public static functionNew_functionExists = 'functionNew_functionExists';
  public static jobType_appendToBlueprint = 'jobType_appendToBlueprint';
  public static jobType_appendToFile = 'jobType_appendToFile';
  public static jobType_createNewApp = 'jobType_createNewApp';
  public static jobType_createNewBlueprint = 'jobType_createNewBlueprint';
  public static binding_storageAccountKey = 'binding_storageAccountKey';
  public static binding_storageAccountName = 'binding_storageAccountName';
  public static binding_storageInfoFooter = 'binding_storageInfoFooter';
  public static binding_storageInfoHeader = 'binding_storageInfoHeader';
  public static binding_storageInfoHeader2 = 'binding_storageInfoHeader2';
  public static binding_storageInfoHeader3 = 'binding_storageInfoHeader3';
  public static learnMore = 'learnMore';
  public static clickToLearnMore = 'clickToLearnMore';
  public static httpRun_addHeader = 'httpRun_addHeader';
  public static httpRun_addParameter = 'httpRun_addParameter';
  public static httpRun_httpMethod = 'httpRun_httpMethod';
  public static httpRun_query = 'httpRun_query';
  public static topBar_alwaysOn = 'topBar_alwaysOn';
  public static topBar_slotsHostId = 'topBar_slotsHostId';
  public static topBar_slotsHostIdV2 = 'topBar_slotsHostIdV2';
  public static topBar_releaseNotes = 'topBar_releaseNotes';
  public static adminKeys_title = 'adminKeys_title';
  public static functionKeys_addNewAdminKey = 'functionKeys_addNewAdminKey';
  public static functionKeys_addNewFunctionKey = 'functionKeys_addNewFunctionKey';
  public static functionKeys_clickToShow = 'functionKeys_clickToShow';
  public static functionKeys_discard = 'functionKeys_discard';
  public static functionKeys_enterKeyName = 'functionKeys_enterKeyName';
  public static functionKeys_enterKeyValue = 'functionKeys_enterKeyValue';
  public static functionKeys_keyName = 'functionKeys_keyName';
  public static functionKeys_keyValue = 'functionKeys_keyValue';
  public static functionKeys_title = 'functionKeys_title';
  public static binding_storageConnectionString = 'binding_storageConnectionString';
  public static functionAppSettings_dailyUsageQuota = 'functionAppSettings_dailyUsageQuota';
  public static functionAppSettings_quotaWarning = 'functionAppSettings_quotaWarning';
  public static functionAppSettings_removeQuota = 'functionAppSettings_removeQuota';
  public static functionAppSettings_setQuota = 'functionAppSettings_setQuota';
  public static functionAppSettings_quotaInfo = 'functionAppSettings_quotaInfo';
  public static functionKeys_revokeConfirmation = 'functionKeys_revokeConfirmation';
  public static keys = 'keys';
  public static functionNew_nameError = 'functionNew_nameError';
  public static functionDev_loading = 'functionDev_loading';
  public static test = 'test';
  public static testFunctionNotSupportedForGitHubWebhook = 'testFunctionNotSupportedForGitHubWebhook';
  public static extensionBundleVersion = 'extensionBundleVersion';
  public static currentRuntimeVersion = 'currentRuntimeVersion';
  public static runtimeVersion = 'runtimeVersion';
  public static runtimeImage = 'runtimeImage';
  public static runtimeImagev1 = 'runtimeImagev1';
  public static runtimeImagev2 = 'runtimeImagev2';
  public static runtimeImageCustom = 'runtimeImageCustom';
  public static error_FunctionExceededQuota = 'error_FunctionExceededQuota';
  public static error_siteStopped = 'error_siteStopped';
  public static error_NoPermissionToAccessApp = 'error_NoPermissionToAccessApp';
  public static errorUniqueParameterName = 'errorUniqueParameterName';
  public static binding_useFunctionReturnValue = 'binding_useFunctionReturnValue';
  public static functionEdit_functionState = 'functionEdit_functionState';
  public static off = 'off';
  public static on = 'on';
  public static grpcOnly = 'grpcOnly';
  public static topBar_functionApiSettings = 'topBar_functionApiSettings';
  public static sidebar_newApiProxy = 'sidebar_newApiProxy';
  public static apiProxy_allMethods = 'apiProxy_allMethods';
  public static apiProxy_allowedHttpMethods = 'apiProxy_allowedHttpMethods';
  public static apiProxy_backendUrl = 'apiProxy_backendUrl';
  public static apiProxy_errorExists = 'apiProxy_errorExists';
  public static apiProxy_name = 'apiProxy_name';
  public static apiProxy_proxyUrl = 'apiProxy_proxyUrl';
  public static apiProxy_routeTemplate = 'apiProxy_routeTemplate';
  public static apiProxy_seectedMethods = 'apiProxy_seectedMethods';
  public static appFunctionSettings_functionAppSettings = 'appFunctionSettings_functionAppSettings';
  public static appFunctionSettings_functionAppSettings1 = 'appFunctionSettings_functionAppSettings1';
  public static appFunctionSettings_functionAppSettings2 = 'appFunctionSettings_functionAppSettings2';
  public static appFunctionSettings_apiProxies = 'appFunctionSettings_apiProxies';
  public static appFunctionSettings_useApiProxies = 'appFunctionSettings_useApiProxies';
  public static sideBar_changeMadeApiProxy = 'sideBar_changeMadeApiProxy';
  public static apiProxy_alreadyExists = 'apiProxy_alreadyExists';
  public static slots_warningDisabled = 'slots_warningDisabled';
  public static discard = 'discard';
  public static sidebar_Functions = 'sidebar_Functions';
  public static intro_signInWithFacebook = 'intro_signInWithFacebook';
  public static intro_signInWithGitHub = 'intro_signInWithGitHub';
  public static intro_signInWithGoogle = 'intro_signInWithGoogle';
  public static intro_signInWithMicrosoft = 'intro_signInWithMicrosoft';
  public static Logout = 'Logout';
  public static apiProxy_backanrUrlStart = 'apiProxy_backanrUrlStart';
  public static functionKeys_copy = 'functionKeys_copy';
  public static functionKeys_renew = 'functionKeys_renew';
  public static functionKeys_revoke = 'functionKeys_revoke';
  public static logStreaming_compress = 'logStreaming_compress';
  public static logStreaming_expand = 'logStreaming_expand';
  public static functionDev_getFunctionUrl = 'functionDev_getFunctionUrl';
  public static functionDev_getGithubSecret = 'functionDev_getGithubSecret';
  public static httpRun_headers = 'httpRun_headers';
  public static httpRun_noHeaders = 'httpRun_noHeaders';
  public static sideNav_AllSubscriptions = 'sideNav_AllSubscriptions';
  public static sideNav_Subscriptions = 'sideNav_Subscriptions';
  public static sideNav_SubscriptionCount = 'sideNav_SubscriptionCount';
  public static sideNav_FunctionsNoAccess = 'sideNav_FunctionsNoAccess';
  public static sideNav_FunctionsReadOnlyLock = 'sideNav_FunctionsReadOnlyLock';
  public static sideNav_FunctionsStopped = 'sideNav_FunctionsStopped';
  public static sideNav_ProxiesNoAccess = 'sideNav_ProxiesNoAccess';
  public static sideNav_ProxiesStopped = 'sideNav_ProxiesStopped';
  public static sideNav_ProxiesReadOnlyLock = 'sideNav_ProxiesReadOnlyLock';
  public static functions = 'functions';
  public static newFunction = 'newFunction';
  public static functionApps = 'functionApps';
  public static stop = 'stop';
  public static start = 'start';
  public static restart = 'restart';
  public static logs = 'logs';
  public static swap = 'swap';
  public static startSwap = 'startSwap';
  public static completeSwap = 'completeSwap';
  public static cancelSwap = 'cancelSwap';
  public static getPublishProfile = 'getPublishProfile';
  public static resetPublishProfile = 'resetPublishProfile';
  public static _delete = '_delete';
  public static status = 'status';
  public static availability = 'availability';
  public static available = 'available';
  public static noAccess = 'noAccess';
  public static notApplicable = 'notApplicable';
  public static notAvailable = 'notAvailable';
  public static enabledFeatures_header = 'enabledFeatures_header';
  public static enabledFeatures_description = 'enabledFeatures_description';
  public static siteDashboard_confirmLoseChanges = 'siteDashboard_confirmLoseChanges';
  public static siteDashboard_getAppError = 'siteDashboard_getAppError';
  public static siteDashboard_appNotFound = 'siteDashboard_appNotFound';
  public static siteDashboard_pinApp = 'siteDashboard_pinApp';
  public static siteSummary_stopConfirmation = 'siteSummary_stopConfirmation';
  public static siteSummary_stopNotifyTitle = 'siteSummary_stopNotifyTitle';
  public static siteSummary_startNotifyTitle = 'siteSummary_startNotifyTitle';
  public static siteSummary_stopNotifySuccess = 'siteSummary_stopNotifySuccess';
  public static siteSummary_startNotifySuccess = 'siteSummary_startNotifySuccess';
  public static siteSummary_stopNotifyFail = 'siteSummary_stopNotifyFail';
  public static siteSummary_startNotifyFail = 'siteSummary_startNotifyFail';
  public static siteSummary_resetProfileConfirmation = 'siteSummary_resetProfileConfirmation';
  public static siteSummary_resetProfileNotifyTitle = 'siteSummary_resetProfileNotifyTitle';
  public static siteSummary_resetProfileNotifySuccess = 'siteSummary_resetProfileNotifySuccess';
  public static siteSummary_resetProfileNotifyFail = 'siteSummary_resetProfileNotifyFail';
  public static siteSummary_deleteConfirmation = 'siteSummary_deleteConfirmation';
  public static siteSummary_deleteNotifyTitle = 'siteSummary_deleteNotifyTitle';
  public static siteSummary_deleteNotifySuccess = 'siteSummary_deleteNotifySuccess';
  public static siteSummary_deleteNotifyFail = 'siteSummary_deleteNotifyFail';
  public static siteSummary_restartConfirmation = 'siteSummary_restartConfirmation';
  public static siteSummary_restartNotifyTitle = 'siteSummary_restartNotifyTitle';
  public static siteSummary_restartNotifySuccess = 'siteSummary_restartNotifySuccess';
  public static siteSummary_restartNotifyFail = 'siteSummary_restartNotifyFail';
  public static featureNotSupportedConsumption = 'featureNotSupportedConsumption';
  public static featureNotSupportedElastic = 'featureNotSupportedElastic';
  public static featureNotSupportedForSlots = 'featureNotSupportedForSlots';
  public static featureNotSupportedForLinuxApps = 'featureNotSupportedForLinuxApps';
  public static featureNotSupportedForLinuxConsumptionApps = 'featureNotSupportedForLinuxConsumptionApps';
  public static featureRequiresWritePermissionOnApp = 'featureRequiresWritePermissionOnApp';
  public static featureDisabledReadOnlyLockOnApp = 'featureDisabledReadOnlyLockOnApp';
  public static featureDisabledNoPermissionToPlan = 'featureDisabledNoPermissionToPlan';
  public static feature_api = 'feature_api';
  public static feature_deploymentSourceName = 'feature_deploymentSourceName';
  public static feature_deploymentSourceInfo = 'feature_deploymentSourceInfo';
  public static feature_deploymentCredsName = 'feature_deploymentCredsName';
  public static feature_deploymentCredsInfo = 'feature_deploymentCredsInfo';
  public static error_consoleNotAvailable = 'error_consoleNotAvailable';
  public static error_consoleCommandFialure = 'error_consoleCommandFialure';
  public static feature_consoleName = 'feature_consoleName';
  public static feature_consoleInfo = 'feature_consoleInfo';
  public static feature_consoleMsg = 'feature_consoleMsg';
  public static feature_cmdConsoleName = 'feature_cmdConsoleName';
  public static feature_powerShellConsoleName = 'feature_powerShellConsoleName';
  public static feature_bashConsoleName = 'feature_bashConsoleName';
  public static feature_sshConsoleName = 'feature_sshConsoleName';
  public static feature_sshName = 'feature_sshName';
  public static feature_sshInfo = 'feature_sshInfo';
  public static ssh_reconnect = 'ssh_reconnect';
  public static ssh_newWindow = 'ssh_newWindow';
  public static feature_extensionsName = 'feature_extensionsName';
  public static feature_extensionsInfo = 'feature_extensionsInfo';
  public static emptyAppSettings = 'emptyAppSettings';
  public static emptyConnectionStrings = 'emptyConnectionStrings';
  public static emptyDefaultDocuments = 'emptyDefaultDocuments';
  public static emptyHandlerMappings = 'emptyHandlerMappings';
  public static emptyVirtualDirectories = 'emptyVirtualDirectories';
  public static feature_generalSettingsName = 'feature_generalSettingsName';
  public static feature_autoSwapSettingsName = 'feature_autoSwapSettingsName';
  public static feature_debuggingSettingsName = 'feature_debuggingSettingsName';
  public static feature_linuxRuntimeName = 'feature_linuxRuntimeName';
  public static feature_applicationSettingsName = 'feature_applicationSettingsName';
  public static feature_applicationSettingsInfo = 'feature_applicationSettingsInfo';
  public static feature_defaultDocumentsName = 'feature_defaultDocumentsName';
  public static feature_handlerMappingsName = 'feature_handlerMappingsName';
  public static feature_virtualDirectoriesName = 'feature_virtualDirectoriesName';
  public static configRequiresWritePermissionOnApp = 'configRequiresWritePermissionOnApp';
  public static configDisabledReadOnlyLockOnApp = 'configDisabledReadOnlyLockOnApp';
  public static configViewReadOnlySettings = 'configViewReadOnlySettings';
  public static configLoadFailure = 'configLoadFailure';
  public static loading = 'loading';
  public static loadingFailed = 'loadingFailed';
  public static configUpdating = 'configUpdating';
  public static configUpdateSuccess = 'configUpdateSuccess';
  public static configUpdateFailure = 'configUpdateFailure';
  public static configUpdateFailureExt = 'configUpdateFailureExt';
  public static configUpdateFailureInvalidInput = 'configUpdateFailureInvalidInput';
  public static netFrameWorkVersionLabel = 'netFrameWorkVersionLabel';
  public static netFrameWorkVersionLabelHelp = 'netFrameWorkVersionLabelHelp';
  public static phpVersionLabel = 'phpVersionLabel';
  public static phpVersionLabelHelp = 'phpVersionLabelHelp';
  public static pythonVersionLabel = 'pythonVersionLabel';
  public static pythonVersionLabelHelp = 'pythonVersionLabelHelp';
  public static pythonInfoText = 'pythonInfoText';
  public static pythonInfoTextNoClick = 'pythonInfoTextNoClick';
  public static javaVersionLabel = 'javaVersionLabel';
  public static javaVersionLabelHelp = 'javaVersionLabelHelp';
  public static javaMinorVersionLabel = 'javaMinorVersionLabel';
  public static javaMinorVersionLabelHelp = 'javaMinorVersionLabelHelp';
  public static javaWebContainerLabel = 'javaWebContainerLabel';
  public static javaWebContainerLabelHelp = 'javaWebContainerLabelHelp';
  public static use32BitWorkerProcessLabel = 'use32BitWorkerProcessLabel';
  public static use32BitWorkerProcessLabelHelp = 'use32BitWorkerProcessLabelHelp';
  public static use32BitWorkerProcessUpsell = 'use32BitWorkerProcessUpsell';
  public static webSocketsEnabledLabel = 'webSocketsEnabledLabel';
  public static webSocketsEnabledLabelHelp = 'webSocketsEnabledLabelHelp';
  public static alwaysOnLabel = 'alwaysOnLabel';
  public static alwaysOnLabelHelp = 'alwaysOnLabelHelp';
  public static alwaysOnUpsell = 'alwaysOnUpsell';
  public static upgradeUpsell = 'upgradeUpsell';
  public static managedPipelineModeLabel = 'managedPipelineModeLabel';
  public static autoSwapNotSupportedFromProd = 'autoSwapNotSupportedFromProd';
  public static autoSwapUpsell = 'autoSwapUpsell';
  public static autoSwapEnabledLabel = 'autoSwapEnabledLabel';
  public static autoSwapSlotNameLabel = 'autoSwapSlotNameLabel';
  public static productionSlotDisplayName = 'productionSlotDisplayName';
  public static clientAffinityEnabledLabel = 'clientAffinityEnabledLabel';
  public static httpsOnlyInfoBoxText = 'httpsOnlyInfoBoxText';
  public static httpsOnlyLabel = 'httpsOnlyLabel';
  public static httpsOnlyInfoBubbleMessage = 'httpsOnlyInfoBubbleMessage';
  public static https20ProxyInfoBubbleMessage = 'https20ProxyInfoBubbleMessage';
  public static basicAuthPublishingCredInfoBubbleMessage = 'basicAuthPublishingCredInfoBubbleMessage';
  public static httpCertWarningInfoBubbleMessage = 'httpCertWarningInfoBubbleMessage';
  public static minTlsVersionLabel = 'minTlsVersionLabel';
  public static minTlsVersionInfoBubbleMessage = 'minTlsVersionInfoBubbleMessage';
  public static minTlsCipherSuiteLabel = 'minTlsCipherSuiteLabel';
  public static vnetPrivatePortsCount = 'vnetPrivatePortsCount';
  public static minTlsCipherSuiteInfoBubbleMessage = 'minTlsCipherSuiteInfoBubbleMessage';
  public static minTlsCipherSuiteSelectionInfo = 'minTlsCipherSuiteSelectionInfo';
  public static minTlsCipherSuiteBannerInfo = 'minTlsCipherSuiteBannerInfo';
  public static minTlsCipherSuiteDropdownLabel = 'minTlsCipherSuiteDropdownLabel';
  public static minTlsCipherSuitePanelHeader = 'minTlsCipherSuitePanelHeader';
  public static minTlsCipherSuiteMostSecure = 'minTlsCipherSuiteMostSecure';
  public static minTlsCipherSuiteLeastSecure = 'minTlsCipherSuiteLeastSecure';
  public static endToEndEncryptionLabel = 'endToEndEncryptionLabel';
  public static endToEndEncryptionInfoMessage = 'endToEndEncryptionInfoMessage';
  public static selected = 'selected';
  public static change = 'change';
  public static clientAffinityInfoText = 'clientAffinityInfoText';
  public static remoteDebuggingEnabledLabel = 'remoteDebuggingEnabledLabel';
  public static remoteDebuggingVersionLabel = 'remoteDebuggingVersionLabel';
  public static linuxFxVersionLabel = 'linuxFxVersionLabel';
  public static linuxFxVersionLabelHelp = 'linuxFxVersionLabelHelp';
  public static appCommandLineLabel = 'appCommandLineLabel';
  public static appCommandLineLabelHelp = 'appCommandLineLabelHelp';
  public static appCommandLineLabelHelpNoLink = 'appCommandLineLabelHelpNoLink';
  public static newest = 'newest';
  public static architecture32 = 'architecture32';
  public static architecture64 = 'architecture64';
  public static pipelineModeClassic = 'pipelineModeClassic';
  public static pipelineModeIntegrated = 'pipelineModeIntegrated';
  public static feature_propertiesName = 'feature_propertiesName';
  public static feature_propertiesInfo = 'feature_propertiesInfo';
  public static feature_backupsName = 'feature_backupsName';
  public static feature_backupsInfo = 'feature_backupsInfo';
  public static feature_allSettingsName = 'feature_allSettingsName';
  public static feature_allSettingsInfo = 'feature_allSettingsInfo';
  public static feature_functionSettingsInfo = 'feature_functionSettingsInfo';
  public static feature_generalSettings = 'feature_generalSettings';
  public static feature_codeDeployment = 'feature_codeDeployment';
  public static feature_deploymentSlotsName = 'feature_deploymentSlotsName';
  public static feature_deploymentSlotsPreviewName = 'feature_deploymentSlotsPreviewName';
  public static feature_developmentTools = 'feature_developmentTools';
  public static feature_networkingName = 'feature_networkingName';
  public static feature_networkingInfo = 'feature_networkingInfo';
  public static feature_sslInfo = 'feature_sslInfo';
  public static feature_customDomainsName = 'feature_customDomainsName';
  public static feature_customDomainsInfo = 'feature_customDomainsInfo';
  public static feature_authName = 'feature_authName';
  public static feature_authInfo = 'feature_authInfo';
  public static feature_msiName = 'feature_msiName';
  public static feature_msiInfo = 'feature_msiInfo';
  public static feature_pushNotificationsName = 'feature_pushNotificationsName';
  public static feature_pushNotificationsInfo = 'feature_pushNotificationsInfo';
  public static feature_logStreamingConnecting = 'feature_logStreamingConnecting';
  public static feature_applicationLogsName = 'feature_applicationLogsName';
  public static feature_webServerLogsName = 'feature_webServerLogsName';
  public static feature_diagnosticLogsName = 'feature_diagnosticLogsName';
  public static feature_diagnosticLogsInfo = 'feature_diagnosticLogsInfo';
  public static feature_logStreamingName = 'feature_logStreamingName';
  public static feature_logStreamingInfo = 'feature_logStreamingInfo';
  public static feature_processExplorerName = 'feature_processExplorerName';
  public static feature_processExplorerInfo = 'feature_processExplorerInfo';
  public static feature_securityScanningName = 'feature_securityScanningName';
  public static feature_securityScanningInfo = 'feature_securityScanningInfo';
  public static feature_monitoring = 'feature_monitoring';
  public static feature_corsInfo = 'feature_corsInfo';
  public static feature_apiManagement = 'feature_apiManagement';
  public static feature_apiManagementInfo = 'feature_apiManagementInfo';
  public static feature_apiDefinitionName = 'feature_apiDefinitionName';
  public static feature_apiDefinitionInfo = 'feature_apiDefinitionInfo';
  public static feature_appServicePlanInfo = 'feature_appServicePlanInfo';
  public static feature_quotasName = 'feature_quotasName';
  public static feature_quotasInfo = 'feature_quotasInfo';
  public static feature_activityLogName = 'feature_activityLogName';
  public static feature_activityLogInfo = 'feature_activityLogInfo';
  public static feature_accessControlName = 'feature_accessControlName';
  public static feature_accessControlInfo = 'feature_accessControlInfo';
  public static feature_tagsName = 'feature_tagsName';
  public static feature_tagsInfo = 'feature_tagsInfo';
  public static feature_locksName = 'feature_locksName';
  public static feature_locksInfo = 'feature_locksInfo';
  public static feature_automationScriptName = 'feature_automationScriptName';
  public static feature_automationScriptInfo = 'feature_automationScriptInfo';
  public static feature_resourceManagement = 'feature_resourceManagement';
  public static feature_diagnoseAndSolveName = 'feature_diagnoseAndSolveName';
  public static feature_diagnoseAndSolveInfo = 'feature_diagnoseAndSolveInfo';
  public static feature_advancedToolsName = 'feature_advancedToolsName';
  public static feature_advancedToolsInfo = 'feature_advancedToolsInfo';
  public static feature_appServiceEditorName = 'feature_appServiceEditorName';
  public static feature_appServiceEditorInfo = 'feature_appServiceEditorInfo';
  public static feature_resourceExplorerName = 'feature_resourceExplorerName';
  public static feature_resourceExplorerInfo = 'feature_resourceExplorerInfo';
  public static featureEnabled_cors = 'featureEnabled_cors';
  public static featureEnabled_deploymentSource = 'featureEnabled_deploymentSource';
  public static featureEnabled_sslCert = 'featureEnabled_sslCert';
  public static featureEnabled_webjobs = 'featureEnabled_webjobs';
  public static featureEnabled_extensions = 'featureEnabled_extensions';
  public static tab_overview = 'tab_overview';
  public static tab_features = 'tab_features';
  public static tab_settings = 'tab_settings';
  public static tab_functionSettings = 'tab_functionSettings';
  public static tab_configuration = 'tab_configuration';
  public static feature_configuration = 'feature_configuration';
  public static tab_applicationSettings = 'tab_applicationSettings';
  public static try_appDisabled = 'try_appDisabled';
  public static template = 'template';
  public static events = 'events';
  public static appServicePlan = 'appServicePlan';
  public static appServicePlanPricingTier = 'appServicePlanPricingTier';
  public static authentication = 'authentication';
  public static authorization = 'authorization';
  public static hybridConnections = 'hybridConnections';
  public static supportRequest = 'supportRequest';
  public static scale = 'scale';
  public static connectionStrings = 'connectionStrings';
  public static debug = 'debug';
  public static continuousDeployment = 'continuousDeployment';
  public static source = 'source';
  public static target = 'target';
  public static options = 'options';
  public static backend_error_CannotAccessFunctionApp = 'backend_error_CannotAccessFunctionApp';
  public static backend_error_CannotAccessFunctionApp_action = 'backend_error_CannotAccessFunctionApp_action';
  public static backend_error_InvalidStorageConnectionString = 'backend_error_InvalidStorageConnectionString';
  public static backend_error_InvalidStorageConnectionString_action = 'backend_error_InvalidStorageConnectionString_action';
  public static backend_error_MissingAzureFilesConnectionString = 'backend_error_MissingAzureFilesConnectionString';
  public static backend_error_MissingAzureFilesContentShare = 'backend_error_MissingAzureFilesContentShare';
  public static backend_error_MissingAzureWebJobsDashboardAppSetting = 'backend_error_MissingAzureWebJobsDashboardAppSetting';
  public static backend_error_MissingAzureWebJobsStorageAppSetting = 'backend_error_MissingAzureWebJobsStorageAppSetting';
  public static backend_error_MissingAzureWebJobsStorageAppSetting_action = 'backend_error_MissingAzureWebJobsStorageAppSetting_action';
  public static backend_error_MissingFunctionsExtensionVersionAppSetting = 'backend_error_MissingFunctionsExtensionVersionAppSetting';
  public static backend_error_StorageAccountConnectionStringIsNullOrEmpty = 'backend_error_StorageAccountConnectionStringIsNullOrEmpty';
  public static backend_error_StorageAccountConnectionStringIsNullOrEmpty_action =
    'backend_error_StorageAccountConnectionStringIsNullOrEmpty_action';
  public static backend_error_StorageAccountDoesNotExist = 'backend_error_StorageAccountDoesNotExist';
  public static backend_error_StorageAccountDoesNotExist_action = 'backend_error_StorageAccountDoesNotExist_action';
  public static backend_error_StorageAccountDoesntSupportQueues = 'backend_error_StorageAccountDoesntSupportQueues';
  public static backend_error_UnexpectedArmError = 'backend_error_UnexpectedArmError';
  public static backend_error_UnknownErrorWhileCallingArm = 'backend_error_UnknownErrorWhileCallingArm';
  public static error_shareCodeWithSupport = 'error_shareCodeWithSupport';
  public static error_parsingFunctionListReturenedFromKudu = 'error_parsingFunctionListReturenedFromKudu';
  public static error_unableToCreateFunction = 'error_unableToCreateFunction';
  public static error_unableToDecryptKeys = 'error_unableToDecryptKeys';
  public static error_unableToDeleteFileThroughKudu = 'error_unableToDeleteFileThroughKudu';
  public static error_unableToDeleteFunction = 'error_unableToDeleteFunction';
  public static error_unableToGetFileContentFromKudu = 'error_unableToGetFileContentFromKudu';
  public static error_unableToRetrieveFunctionListFromKudu = 'error_unableToRetrieveFunctionListFromKudu';
  public static error_UnableToRetrieveSecretsFileFromKudu = 'error_UnableToRetrieveSecretsFileFromKudu';
  public static error_unableToSaveFileContentThroughKudu = 'error_unableToSaveFileContentThroughKudu';
  public static error_unableToRetrieveDirectoryContent = 'error_unableToRetrieveDirectoryContent';
  public static error_unableToRetrieveFunction = 'error_unableToRetrieveFunction';
  public static error_unableToSaveFunction = 'error_unableToSaveFunction';
  public static error_unableToRetrieveRuntimeConfig = 'error_unableToRetrieveRuntimeConfig';
  public static error_unableToRetrieveRuntimeKey = 'error_unableToRetrieveRuntimeKey';
  public static error_unableToUpdateFunction = 'error_unableToUpdateFunction';
  public static error_functionRuntimeIsUnableToStart = 'error_functionRuntimeIsUnableToStart';
  public static error_unableToCreateFunctionKey = 'error_unableToCreateFunctionKey';
  public static error_unableToDeleteFunctionKey = 'error_unableToDeleteFunctionKey';
  public static error_unableToRenewFunctionKey = 'error_unableToRenewFunctionKey';
  public static error_unableToRetrieveFunctionKeys = 'error_unableToRetrieveFunctionKeys';
  public static error_appOffline = 'error_appOffline';
  public static error_uploadHTMLFile = 'error_uploadHTMLFile';
  public static functionKeys_actions = 'functionKeys_actions';
  public static functionNew_chooseTemplateQuickstart = 'functionNew_chooseTemplateQuickstart';
  public static httpRun_noQuery = 'httpRun_noQuery';
  public static swaggerDefinition_collapse = 'swaggerDefinition_collapse';
  public static swaggerDefinition_delete = 'swaggerDefinition_delete';
  public static swaggerDefinition_documentation = 'swaggerDefinition_documentation';
  public static swaggerDefinition_expand = 'swaggerDefinition_expand';
  public static swaggerDefinition_external = 'swaggerDefinition_external';
  public static swaggerDefinition_feature_overview = 'swaggerDefinition_feature_overview';
  public static swaggerDefinition_getting_started = 'swaggerDefinition_getting_started';
  public static swaggerDefinition_internal = 'swaggerDefinition_internal';
  public static swaggerDefinition_key = 'swaggerDefinition_key';
  public static swaggerDefinition_loadDefinition = 'swaggerDefinition_loadDefinition';
  public static swaggerDefinition_loadGeneratedDefinition = 'swaggerDefinition_loadGeneratedDefinition';
  public static swaggerDefinition_powerAppsFlow = 'swaggerDefinition_powerAppsFlow';
  public static swaggerDefinition_prompt = 'swaggerDefinition_prompt';
  public static swaggerDefinition_renew = 'swaggerDefinition_renew';
  public static swaggerDefinition_setExternal = 'swaggerDefinition_setExternal';
  public static swaggerDefinition_source = 'swaggerDefinition_source';
  public static swaggerDefinition_subtitle = 'swaggerDefinition_subtitle';
  public static swaggerDefinition_title = 'swaggerDefinition_title';
  public static swaggerDefinition_url = 'swaggerDefinition_url';
  public static swaggerDefinition_useAPIdefinition = 'swaggerDefinition_useAPIdefinition';
  public static tab_api_definition = 'tab_api_definition';
  public static error_unableToCreateSwaggerKey = 'error_unableToCreateSwaggerKey';
  public static error_unableToDeleteSwaggerData = 'error_unableToDeleteSwaggerData';
  public static error_unableToGetSystemKey = 'error_unableToGetSystemKey';
  public static error_unableToloadGeneratedAPIDefinition = 'error_unableToloadGeneratedAPIDefinition';
  public static error_unableToUpdateRuntimeConfig = 'error_unableToUpdateRuntimeConfig';
  public static error_unableToUpdateSwaggerData = 'error_unableToUpdateSwaggerData';
  public static swaggerDefinition_revert = 'swaggerDefinition_revert';
  public static binding_AADLinkAuth = 'binding_AADLinkAuth';
  public static swaggerDefinition_placeHolder = 'swaggerDefinition_placeHolder';
  public static swaggerDefinition_confirmOverwrite = 'swaggerDefinition_confirmOverwrite';
  public static swaggerDefinition_exporthelp = 'swaggerDefinition_exporthelp';
  public static swaggerDefinition_generateHelp = 'swaggerDefinition_generateHelp';
  public static swaggerDefinition_keyHelp = 'swaggerDefinition_keyHelp';
  public static swaggerDefinition_sourceHelp = 'swaggerDefinition_sourceHelp';
  public static swaggerDefinition_urlHelp = 'swaggerDefinition_urlHelp';
  public static featureEnabled_appInsights = 'featureEnabled_appInsights';
  public static appFunctionSettings_changeEditMode = 'appFunctionSettings_changeEditMode';
  public static appFunctionSettings_editMode = 'appFunctionSettings_editMode';
  public static appFunctionSettings_readOnlyMode = 'appFunctionSettings_readOnlyMode';
  public static appFunctionSettings_readWriteMode = 'appFunctionSettings_readWriteMode';
  public static validation_decimalFormatError = 'validation_decimalFormatError';
  public static validation_decimalRangeValueError = 'validation_decimalRangeValueError';
  public static validation_duplicateError = 'validation_duplicateError';
  public static validation_error = 'validation_error';
  public static validation_linuxAppSettingNameError = 'validation_linuxAppSettingNameError';
  public static validation_requiredError = 'validation_requiredError';
  public static validation_routingTotalPercentError = 'validation_routingTotalPercentError';
  public static validation_siteNameMinChars = 'validation_siteNameMinChars';
  public static validation_siteNameMaxChars = 'validation_siteNameMaxChars';
  public static validation_slotNameMaxChars = 'validation_slotNameMaxChars';
  public static validation_siteNameInvalidChar = 'validation_siteNameInvalidChar';
  public static validation_siteNameNotAvailable = 'validation_siteNameNotAvailable';
  public static validation_slotNameNotAvailable = 'validation_slotNameNotAvailable';
  public static validation_slotNameReserved = 'validation_slotNameReserved';
  public static validation_fieldMaxCharacters = 'validation_fieldMaxCharacters';
  public static validation_shareNameAllowedCharacters = 'validation_shareNameAllowedCharacters';
  public static mountPath_info = 'mountPath_info';
  public static validation_invalidMountPath = 'validation_invalidMountPath';
  public static validation_mountPathNotHome = 'validation_mountPathNotHome';
  public static validation_mouthPathMustBeUnique = 'validation_mouthPathMustBeUnique';
  public static error_unableToUpdateFunctionAppEditMode = 'error_unableToUpdateFunctionAppEditMode';
  public static readOnly = 'readOnly';
  public static readWriteSourceControlled = 'readWriteSourceControlled';
  public static readOnlyGeneratedBy = 'readOnlyGeneratedBy';
  public static readWriteGeneratedBy = 'readWriteGeneratedBy';
  public static readOnlyRbac = 'readOnlyRbac';
  public static copypre_copy = 'copypre_copy';
  public static keysDialog_getFunctionUrl = 'keysDialog_getFunctionUrl';
  public static keysDialog_key = 'keysDialog_key';
  public static keysDialog_url = 'keysDialog_url';
  public static downloadFunctionAppContent = 'downloadFunctionAppContent';
  public static functionKeys_renewConfirmation = 'functionKeys_renewConfirmation';
  public static emptyBrowse = 'emptyBrowse';
  public static emptyBrowse_learnMore = 'emptyBrowse_learnMore';
  public static eventHubPicker_eventHub = 'eventHubPicker_eventHub';
  public static eventHubPicker_namespace = 'eventHubPicker_namespace';
  public static notFound = 'notFound';
  public static eventHubPicker_IOTEndpoint = 'eventHubPicker_IOTEndpoint';
  public static emptyBrowse_title = 'emptyBrowse_title';
  public static appFunctionSettings_slotsDesc = 'appFunctionSettings_slotsDesc';
  public static appFunctionSettings_slotsEnable = 'appFunctionSettings_slotsEnable';
  public static appFunctionSettings_slotsEnableWarning = 'appFunctionSettings_slotsEnableWarning';
  public static appFunctionSettings_warning_1 = 'appFunctionSettings_warning_1';
  public static appFunctionSettings_warning_2 = 'appFunctionSettings_warning_2';
  public static appFunctionSettings_warning_3 = 'appFunctionSettings_warning_3';
  public static slotCreateOperationInProgressWarning = 'slotCreateOperationInProgressWarning';
  public static slots_label = 'slots_label';
  public static slotsPreview_label = 'slotsPreview_label';
  public static slotNew = 'slotNew';
  public static slotNew_nameLabel = 'slotNew_nameLabel';
  public static slotNew_cloneConfigLabel = 'slotNew_cloneConfigLabel';
  public static slotNew_dontCloneConfig = 'slotNew_dontCloneConfig';
  public static slotNew_heading = 'slotNew_heading';
  public static slotNew_desc = 'slotNew_desc';
  public static slotNew_startCreateNotifyTitle = 'slotNew_startCreateNotifyTitle';
  public static slotNew_startCreateSuccessNotifyTitle = 'slotNew_startCreateSuccessNotifyTitle';
  public static slotNew_startCreateFailureNotifyTitle = 'slotNew_startCreateFailureNotifyTitle';
  public static slotNew_startCreateFailureNotifyTitleExt = 'slotNew_startCreateFailureNotifyTitleExt';
  public static error_unableToLoadSlotsList = 'error_unableToLoadSlotsList';
  public static error_unableToLoadTipConfig = 'error_unableToLoadTipConfig';
  public static error_unableToLoadConfig = 'error_unableToLoadConfig';
  public static error_unableToLoadSite = 'error_unableToLoadSite';
  public static slotNew_quotaReached = 'slotNew_quotaReached';
  public static slotNew_quotaUpgrade = 'slotNew_quotaUpgrade';
  public static slotNew_noAccess = 'slotNew_noAccess';
  public static slots_upgrade = 'slots_upgrade';
  public static slots_description = 'slots_description';
  public static slotsDiff_settingHeader = 'slotsDiff_settingHeader';
  public static slotsDiff_typeHeader = 'slotsDiff_typeHeader';
  public static slotsDiff_oldValueHeader = 'slotsDiff_oldValueHeader';
  public static slotsDiff_newValueHeader = 'slotsDiff_newValueHeader';
  public static slotsDiff_currentValueHeader = 'slotsDiff_currentValueHeader';
  public static slotsDiff_tempValueHeader = 'slotsDiff_tempValueHeader';
  public static slotsList_noSlots = 'slotsList_noSlots';
  public static slotsList_nameHeader = 'slotsList_nameHeader';
  public static slotsList_statusHeader = 'slotsList_statusHeader';
  public static slotsList_serverfarmHeader = 'slotsList_serverfarmHeader';
  public static slotsList_trafficPercentHeader = 'slotsList_trafficPercentHeader';
  public static monitoring_appInsights = 'monitoring_appInsights';
  public static monitoring_appInsightsConfigureLink = 'monitoring_appInsightsConfigureLink';
  public static slotNew_nameLabel_balloonText = 'slotNew_nameLabel_balloonText';
  public static slotNew_dynamicQuotaReached = 'slotNew_dynamicQuotaReached';
  public static functionsList_searchFunctions = 'functionsList_searchFunctions';
  public static new_ = 'new_';
  public static createNew = 'createNew';
  public static functionManage_deleteFunction = 'functionManage_deleteFunction';
  public static functionService_clientCertEnabled = 'functionService_clientCertEnabled';
  public static readOnlySlots = 'readOnlySlots';
  public static functionRuntime_manageAppSettings = 'functionRuntime_manageAppSettings';
  public static eventHubPicker_IOTHub = 'eventHubPicker_IOTHub';
  public static eventHubPicker_appSettingName = 'eventHubPicker_appSettingName';
  public static eventHubPicker_appSettingValue = 'eventHubPicker_appSettingValue';
  public static eventHubPicker_connection = 'eventHubPicker_connection';
  public static eventHubPicker_custom = 'eventHubPicker_custom';
  public static eventHubPicker_IOTEvents = 'eventHubPicker_IOTEvents';
  public static eventHubPicker_IOTMonitoring = 'eventHubPicker_IOTMonitoring';
  public static eventHubPicker_policy = 'eventHubPicker_policy';
  public static error_schemaValidationProxies = 'error_schemaValidationProxies';
  public static functionAppSettings_dailyUsageQuotaHelp = 'functionAppSettings_dailyUsageQuotaHelp';
  public static eventHubPicker_eventHubPolicy = 'eventHubPicker_eventHubPolicy';
  public static eventHubPicker_namespacePolicy = 'eventHubPicker_namespacePolicy';
  public static serviceBusPicker_serviceBus = 'serviceBusPicker_serviceBus';
  public static bindingInput_appSettingNotFound = 'bindingInput_appSettingNotFound';
  public static bindingInput_show = 'bindingInput_show';
  public static appSettingPicker_add = 'appSettingPicker_add';
  public static storage_add = 'storage_add';
  public static storage_accountName = 'storage_accountName';
  public static storage_accountKey = 'storage_accountKey';
  public static storage_appSettingName = 'storage_appSettingName';
  public static storage_appSettingName_empty_text = 'storage_appSettingName_empty_text';
  public static storage_endpoint = 'storage_endpoint';
  public static storage_endpoint_azure = 'storage_endpoint_azure';
  public static storage_endpoint_other = 'storage_endpoint_other';
  public static storage_endpoint_empty_text = 'storage_endpoint_empty_text';
  public static sql_add = 'sql_add';
  public static sql_endpoint = 'sql_endpoint';
  public static sql_database_name = 'sql_database_name';
  public static sql_user_name = 'sql_user_name';
  public static sql_password = 'sql_password';
  public static download = 'download';
  public static downloadFunctionAppContent_includeAppSettings = 'downloadFunctionAppContent_includeAppSettings';
  public static downloadFunctionAppContent_includeAppSettingsHelp = 'downloadFunctionAppContent_includeAppSettingsHelp';
  public static downloadFunctionAppContent_siteContent = 'downloadFunctionAppContent_siteContent';
  public static downloadFunctionAppContent_vsProject = 'downloadFunctionAppContent_vsProject';
  public static bindingInput_retrieve = 'bindingInput_retrieve';
  public static apiProxy_delete = 'apiProxy_delete';
  public static apiProxy_new = 'apiProxy_new';
  public static apiProxy_noOverride = 'apiProxy_noOverride';
  public static expressAADRegistration = 'expressAADRegistration';
  public static eventGrid_create = 'eventGrid_create';
  public static eventGrid_createConnection = 'eventGrid_createConnection';
  public static eventGrid_createMessage = 'eventGrid_createMessage';
  public static eventGrid_help = 'eventGrid_help';
  public static eventGrid_label = 'eventGrid_label';
  public static eventGrid_manageSubscriptions = 'eventGrid_manageSubscriptions';
  public static functionDev_addEventGrid = 'functionDev_addEventGrid';
  public static allLocations = 'allLocations';
  public static locationCount = 'locationCount';
  public static locationColon = 'locationColon';
  public static grouping_location = 'grouping_location';
  public static grouping_none = 'grouping_none';
  public static grouping_resourceGroup = 'grouping_resourceGroup';
  public static grouping_subscription = 'grouping_subscription';
  public static southcentralus = 'southcentralus';
  public static northeurope = 'northeurope';
  public static westeurope = 'westeurope';
  public static southeastasia = 'southeastasia';
  public static koreacentral = 'koreacentral';
  public static koreasouth = 'koreasouth';
  public static westus = 'westus';
  public static eastus = 'eastus';
  public static japanwest = 'japanwest';
  public static japaneast = 'japaneast';
  public static eastasia = 'eastasia';
  public static eastus2 = 'eastus2';
  public static northcentralus = 'northcentralus';
  public static centralus = 'centralus';
  public static brazilsouth = 'brazilsouth';
  public static australiaeast = 'australiaeast';
  public static australiasoutheast = 'australiasoutheast';
  public static westindia = 'westindia';
  public static centralindia = 'centralindia';
  public static southindia = 'southindia';
  public static canadacentral = 'canadacentral';
  public static canadaeast = 'canadaeast';
  public static westcentralus = 'westcentralus';
  public static ukwest = 'ukwest';
  public static uksouth = 'uksouth';
  public static westus2 = 'westus2';
  public static allResourceGroups = 'allResourceGroups';
  public static resourceGroupColon = 'resourceGroupColon';
  public static resourceGroupCount = 'resourceGroupCount';
  public static rrOverride_boby = 'rrOverride_boby';
  public static rrOverride_code = 'rrOverride_code';
  public static rrOverride_message = 'rrOverride_message';
  public static rrOverride_request = 'rrOverride_request';
  public static rrOverride_response = 'rrOverride_response';
  public static optional = 'optional';
  public static gitCloneUri = 'gitCloneUri';
  public static rollbackEnabled = 'rollbackEnabled';
  public static scmType = 'scmType';
  public static redeploy = 'redeploy';
  public static activity = 'activity';
  public static active = 'active';
  public static time = 'time';
  public static log = 'log';
  public static showLogs = 'showLogs';
  public static commitIdAuthor = 'commitIdAuthor';
  public static commitAuthor = 'commitAuthor';
  public static checkinMessage = 'checkinMessage';
  public static topBar_runtimeV2 = 'topBar_runtimeV2';
  public static functionKeys_clickToHide = 'functionKeys_clickToHide';
  public static feature_logicAppsInfo = 'feature_logicAppsInfo';
  public static tab_logicApps = 'tab_logicApps';
  public static associatedLogicApps_title = 'associatedLogicApps_title';
  public static orchestrateWithLogicApps_title = 'orchestrateWithLogicApps_title';
  public static createLogicApps = 'createLogicApps';
  public static noLogicApps_title = 'noLogicApps_title';
  public static logicApps = 'logicApps';
  public static logicApp_description = 'logicApp_description';
  public static expandCollapse = 'expandCollapse';
  public static aadreg_appService = 'aadreg_appService';
  public static aadreg_configureAADNow = 'aadreg_configureAADNow';
  public static aadreg_configureAADPermissionsNow = 'aadreg_configureAADPermissionsNow';
  public static aadreg_configured = 'aadreg_configured';
  public static aadreg_identityRequirements = 'aadreg_identityRequirements';
  public static aadreg_notConfigured = 'aadreg_notConfigured';
  public static aadreg_requiredPerm = 'aadreg_requiredPerm';
  public static aadreg_templateNeeds = 'aadreg_templateNeeds';
  public static aadreg_thisIntegration = 'aadreg_thisIntegration';
  public static aadreg_thisTemplate = 'aadreg_thisTemplate';
  public static aadreg_youMayNeed = 'aadreg_youMayNeed';
  public static asdreg_manageAppService = 'asdreg_manageAppService';
  public static aadreg_authConfRequired = 'aadreg_authConfRequired';
  public static aadreg_identityRequirementsInfo = 'aadreg_identityRequirementsInfo';
  public static aadreg_manage = 'aadreg_manage';
  public static failedToGetFunctionRuntimeExtensions = 'failedToGetFunctionRuntimeExtensions';
  public static failedToInstallFunctionRuntimeExtension = 'failedToInstallFunctionRuntimeExtension';
  public static failedToUnInstallFunctionRuntimeExtension = 'failedToUnInstallFunctionRuntimeExtension';
  public static timeoutInstallingFunctionRuntimeExtension = 'timeoutInstallingFunctionRuntimeExtension';
  public static extensionAlreadyInstalledWithDifferentVersion = 'extensionAlreadyInstalledWithDifferentVersion';
  public static monitoring_appInsightsOpen = 'monitoring_appInsightsOpen';
  public static monitoring_appInsightsSetUp = 'monitoring_appInsightsSetUp';
  public static monitoring_noMonitoring = 'monitoring_noMonitoring';
  public static extension_install_button = 'extension_install_button';
  public static extension_install_success = 'extension_install_success';
  public static extension_install_warning = 'extension_install_warning';
  public static extension_integrate_warning = 'extension_integrate_warning';
  public static extension_template_warning = 'extension_template_warning';
  public static installingExtension = 'installingExtension';
  public static failedToInstallFunctionRuntimeExtensionForId = 'failedToInstallFunctionRuntimeExtensionForId';
  public static functionAppSettings_quotaPlaceHolder = 'functionAppSettings_quotaPlaceHolder';
  public static notificationHubPicker_connection = 'notificationHubPicker_connection';
  public static notificationHubPicker_notificationHub = 'notificationHubPicker_notificationHub';
  public static java_splash_line_1 = 'java_splash_line_1';
  public static java_splash_line_2 = 'java_splash_line_2';
  public static appFunctionSettings_proxyEnabled = 'appFunctionSettings_proxyEnabled';
  public static java_splash_button = 'java_splash_button';
  public static nameColon = 'nameColon';
  public static createFunction_search = 'createFunction_search';
  public static bindingInput_hide = 'bindingInput_hide';
  public static monitoring_appInsightsIsNotFound = 'monitoring_appInsightsIsNotFound';
  public static table_startOfRow = 'table_startOfRow';
  public static table_endOfRow = 'table_endOfRow';
  public static appFunctionSettings_warning_6 = 'appFunctionSettings_warning_6';
  public static appFunctionSettings_warning_7 = 'appFunctionSettings_warning_7';
  public static warning = 'warning';
  public static authorizedAs = 'authorizedAs';
  public static continue = 'continue';
  public static authorize = 'authorize';
  public static changeAuthorization = 'changeAuthorization';
  public static back = 'back';
  public static finish = 'finish';
  public static code = 'code';
  public static repository = 'repository';
  public static branch = 'branch';
  public static folder = 'folder';
  public static repoType = 'repoType';
  public static organization = 'organization';
  public static vstsAccount = 'vstsAccount';
  public static project = 'project';
  public static build = 'build';
  public static account = 'account';
  public static loadTest = 'loadTest';
  public static slot = 'slot';
  public static production = 'production';
  public static entity = 'entity';
  public static entityColon = 'entityColon';
  public static swaggerDefinition_notSupportedForV2 = 'swaggerDefinition_notSupportedForV2';
  public static deployedSuccessfully = 'deployedSuccessfully';
  public static deployedSuccessfullyTo = 'deployedSuccessfullyTo';
  public static deployedFailed = 'deployedFailed';
  public static deployedFailedTo = 'deployedFailedTo';
  public static swapWithPreviewLabel = 'swapWithPreviewLabel';
  public static swapWithPreviewInfoText = 'swapWithPreviewInfoText';
  public static swapPhaseOneLabel = 'swapPhaseOneLabel';
  public static swapPhaseTwoLabel = 'swapPhaseTwoLabel';
  public static swapOperationInProgressWarning = 'swapOperationInProgressWarning';
  public static swapOperation = 'swapOperation';
  public static swapFull = 'swapFull';
  public static swapPhaseOne = 'swapPhaseOne';
  public static swapPhaseTwo = 'swapPhaseTwo';
  public static swapStarted = 'swapStarted';
  public static swapSuccess = 'swapSuccess';
  public static swapFailure = 'swapFailure';
  public static swapTimeout = 'swapTimeout';
  public static swapCancelStarted = 'swapCancelStarted';
  public static swapCancelSuccess = 'swapCancelSuccess';
  public static swapCancelFailure = 'swapCancelFailure';
  public static swappedSlotSuccess = 'swappedSlotSuccess';
  public static swappedSlotFail = 'swappedSlotFail';
  public static setupCDSuccessAndTriggerBuild = 'setupCDSuccessAndTriggerBuild';
  public static setupCDSuccess = 'setupCDSuccess';
  public static setupCDFail = 'setupCDFail';
  public static createVSTSAccountSuccess = 'createVSTSAccountSuccess';
  public static createVSTSAccountFail = 'createVSTSAccountFail';
  public static createdNewSlotSuccess = 'createdNewSlotSuccess';
  public static createdNewSlotFail = 'createdNewSlotFail';
  public static createTestWebAppSuccess = 'createTestWebAppSuccess';
  public static createTestWebAppFail = 'createTestWebAppFail';
  public static disconnectCICDVSOSuccess = 'disconnectCICDVSOSuccess';
  public static appServiceStartSuccess = 'appServiceStartSuccess';
  public static appServiceStartFail = 'appServiceStartFail';
  public static appServiceStopSuccess = 'appServiceStopSuccess';
  public static appServiceStopFail = 'appServiceStopFail';
  public static appServiceRestartSuccess = 'appServiceRestartSuccess';
  public static appServiceRestartFail = 'appServiceRestartFail';
  public static vsoSync = 'vsoSync';
  public static buildDefinition = 'buildDefinition';
  public static releaseDefinition = 'releaseDefinition';
  public static buildTriggered = 'buildTriggered';
  public static webApp = 'webApp';
  public static vsoAccount = 'vsoAccount';
  public static viewInstructions = 'viewInstructions';
  public static buildUrl = 'buildUrl';
  public static releaseUrl = 'releaseUrl';
  public static sourceVersionUrl = 'sourceVersionUrl';
  public static deploymentCenter = 'deploymentCenter';
  public static sourceControl = 'sourceControl';
  public static buildProvider = 'buildProvider';
  public static deploy = 'deploy';
  public static summary = 'summary';
  public static experimentalLanguageSupport = 'experimentalLanguageSupport';
  public static sourceProvider = 'sourceProvider';
  public static onedriveDesc = 'onedriveDesc';
  public static githubDesc = 'githubDesc';
  public static vstsDesc = 'vstsDesc';
  public static externalDesc = 'externalDesc';
  public static bitbucketDesc = 'bitbucketDesc';
  public static localGitDesc = 'localGitDesc';
  public static dropboxDesc = 'dropboxDesc';
  public static temp_category_durableFunctions = 'temp_category_durableFunctions';
  public static DurableFunctionsActivity_description = 'DurableFunctionsActivity_description';
  public static DurableFunctionsOrchestrator_description = 'DurableFunctionsOrchestrator_description';
  public static DurableFunctionsHttpStart_description = 'DurableFunctionsHttpStart_description';
  public static functionsPreviewTitle = 'functionsPreviewTitle';
  public static readOnlyRunFromZip = 'readOnlyRunFromZip';
  public static readOnlyVsCodeForTheWeb = 'readOnlyVsCodeForTheWeb';
  public static diagnostics_code = 'diagnostics_code';
  public static diagnostics_column = 'diagnostics_column';
  public static diagnostics_description = 'diagnostics_description';
  public static diagnostics_errorsAndWarnings = 'diagnostics_errorsAndWarnings';
  public static diagnostics_file = 'diagnostics_file';
  public static diagnostics_line = 'diagnostics_line';
  public static pricing_recommendedTiers = 'pricing_recommendedTiers';
  public static pricing_additionalTiers = 'pricing_additionalTiers';
  public static pricing_subscriptionNotAllowed = 'pricing_subscriptionNotAllowed';
  public static pricing_devTestTitle = 'pricing_devTestTitle';
  public static pricing_devTestDesc = 'pricing_devTestDesc';
  public static pricing_productionTitle = 'pricing_productionTitle';
  public static pricing_productionDesc = 'pricing_productionDesc';
  public static pricing_isolatedTitle = 'pricing_isolatedTitle';
  public static pricing_isolatedDesc = 'pricing_isolatedDesc';
  public static pricing_notAvailableConsumption = 'pricing_notAvailableConsumption';
  public static pricing_noWritePermissionsOnPlan = 'pricing_noWritePermissionsOnPlan';
  public static pricing_noWritePermissionsOnPlanFormat = 'pricing_noWritePermissionsOnPlanFormat';
  public static pricing_upsellToPremiumV2Message = 'pricing_upsellToPremiumV2Message';
  public static pricing_planReadonlyLockFormat = 'pricing_planReadonlyLockFormat';
  public static pricing_planUpdateTitle = 'pricing_planUpdateTitle';
  public static pricing_planUpdateDesc = 'pricing_planUpdateDesc';
  public static pricing_planUpdateSuccessFormat = 'pricing_planUpdateSuccessFormat';
  public static pricing_planUpdateJobSuccessFormat = 'pricing_planUpdateJobSuccessFormat';
  public static pricing_planScaleInProgress = 'pricing_planScaleInProgress';
  public static pricing_planUpdateFailFormat = 'pricing_planUpdateFailFormat';
  public static pricing_includedFeatures = 'pricing_includedFeatures';
  public static pricing_includedFeaturesDesc = 'pricing_includedFeaturesDesc';
  public static pricing_includedHardware = 'pricing_includedHardware';
  public static pricing_includedHardwareDesc = 'pricing_includedHardwareDesc';
  public static pricing_includedHardware_azureComputeUnits = 'pricing_includedHardware_azureComputeUnits';
  public static pricing_linuxTrial = 'pricing_linuxTrial';
  public static pricing_emptyIsolatedGroup = 'pricing_emptyIsolatedGroup';
  public static pricing_emptyIsolatedGroupNewPlan = 'pricing_emptyIsolatedGroupNewPlan';
  public static pricing_emptyIsolatedGroupNewPlanLinkText = 'pricing_emptyIsolatedGroupNewPlanLinkText';
  public static pricing_emptyDevTestGroup = 'pricing_emptyDevTestGroup';
  public static pricing_emptyProdGroup = 'pricing_emptyProdGroup';
  public static pricing_pv2NotAvailable = 'pricing_pv2NotAvailable';
  public static pricing_epNotAvailable = 'pricing_epNotAvailable';
  public static pricing_scaleUp = 'pricing_scaleUp';
  public static pricing_pv2UpsellInfoMessage = 'pricing_pv2UpsellInfoMessage';
  public static free = 'free';
  public static pricing_freeLinuxNotAvailable = 'pricing_freeLinuxNotAvailable';
  public static pricing_pricePerMonth = 'pricing_pricePerMonth';
  public static pricing_pricePerMonthBaseline = 'pricing_pricePerMonthBaseline';
  public static pricing_scaleUpDescription = 'pricing_scaleUpDescription';
  public static pricing_applyButtonLabel = 'pricing_applyButtonLabel';
  public static pricing_sharedInfrastructure = 'pricing_sharedInfrastructure';
  public static pricing_sharedCpu = 'pricing_sharedCpu';
  public static pricing_computeDedicatedAcu = 'pricing_computeDedicatedAcu';
  public static pricing_sharedMemory = 'pricing_sharedMemory';
  public static pricing_dedicatedMemory = 'pricing_dedicatedMemory';
  public static pricing_sharedDisk = 'pricing_sharedDisk';
  public static pricing_customDomainsSsl = 'pricing_customDomainsSsl';
  public static pricing_customDomainsSslDesc = 'pricing_customDomainsSslDesc';
  public static pricing_jboss = 'pricing_jboss';
  public static pricing_jbossDesc = 'pricing_jbossDesc';
  public static pricing_customDomainsIpSslDesc = 'pricing_customDomainsIpSslDesc';
  public static pricing_manualScale = 'pricing_manualScale';
  public static pricing_rapidScale = 'pricing_rapidScale';
  public static pricing_rapidScaleDesc = 'pricing_rapidScaleDesc';
  public static pricing_autoScale = 'pricing_autoScale';
  public static pricing_scaleOut = 'pricing_scaleOut';
  public static pricing_computeVmSize = 'pricing_computeVmSize';
  public static pricing_notEnoughInstances = 'pricing_notEnoughInstances';
  public static pricing_largeScale = 'pricing_largeScale';
  public static pricing_largeScaleDesc = 'pricing_largeScaleDesc';
  public static pricing_scaleDesc = 'pricing_scaleDesc';
  public static pricing_scaleDescUnlimited = 'pricing_scaleDescUnlimited';
  public static pricing_highDensity = 'pricing_highDensity';
  public static pricing_highDensityDesc = 'pricing_highDensityDesc';
  public static pricing_stagingSlots = 'pricing_stagingSlots';
  public static pricing_slotsDesc = 'pricing_slotsDesc';
  public static pricing_dailyBackup = 'pricing_dailyBackup';
  public static pricing_dailyBackups = 'pricing_dailyBackups';
  public static pricing_dailyBackupDesc = 'pricing_dailyBackupDesc';
  public static pricing_trafficManager = 'pricing_trafficManager';
  public static pricing_trafficManagerDesc = 'pricing_trafficManagerDesc';
  public static pricing_ase = 'pricing_ase';
  public static pricing_aseDesc = 'pricing_aseDesc';
  public static pricing_isolatedNetwork = 'pricing_isolatedNetwork';
  public static pricing_isolatedNetworkDesc = 'pricing_isolatedNetworkDesc';
  public static pricing_virtualNetwork = 'pricing_virtualNetwork';
  public static pricing_virtualNetworkDesc = 'pricing_virtualNetworkDesc';
  public static pricing_privateAppAccess = 'pricing_privateAppAccess';
  public static pricing_privateAppAccessDesc = 'pricing_privateAppAccessDesc';
  public static pricing_memory = 'pricing_memory';
  public static pricing_computeLimit = 'pricing_computeLimit';
  public static pricing_numCores = 'pricing_numCores';
  public static pricing_aSeriesComputeEquivalent = 'pricing_aSeriesComputeEquivalent';
  public static pricing_dSeriesComputeEquivalent = 'pricing_dSeriesComputeEquivalent';
  public static proxyJsonInvalid = 'proxyJsonInvalid';
  public static schemaJsonInvalid = 'schemaJsonInvalid';
  public static operationId = 'operationId';
  public static date = 'date';
  public static url = 'url';
  public static resultCode = 'resultCode';
  public static triggerReason = 'triggerReason';
  public static error = 'error';
  public static runInAppInsights = 'runInAppInsights';
  public static appInsightsInstance = 'appInsightsInstance';
  public static liveAppMetrics = 'liveAppMetrics';
  public static viewLiveAppMetrics = 'viewLiveAppMetrics';
  public static success = 'success';
  public static duration = 'duration';
  public static functionMonitor_successAggregate_30days = 'functionMonitor_successAggregate_30days';
  public static functionMonitor_errorsAggregate_30days = 'functionMonitor_errorsAggregate_30days';
  public static functionMonitor_appInsightsQueryReturnedTitle = 'functionMonitor_appInsightsQueryReturnedTitle';
  public static functionMonitor_message = 'functionMonitor_message';
  public static functionMonitor_itemCount = 'functionMonitor_itemCount';
  public static functionMonitor_logLevel = 'functionMonitor_logLevel';
  public static vstsBuildServerTitle = 'vstsBuildServerTitle';
  public static vstsBuildServerDesc = 'vstsBuildServerDesc';
  public static kuduTitle = 'kuduTitle';
  public static kuduDesc = 'kuduDesc';
  public static selectAccount = 'selectAccount';
  public static enterAccountName = 'enterAccountName';
  public static selectProject = 'selectProject';
  public static selectFile = 'selectFile';
  public static webAppFramework = 'webAppFramework';
  public static selectFramework = 'selectFramework';
  public static workingDirectory = 'workingDirectory';
  public static clearDirtyConfirmation = 'clearDirtyConfirmation';
  public static taskRunner = 'taskRunner';
  public static pythonFramework = 'pythonFramework';
  public static pythonVersion = 'pythonVersion';
  public static djangoSettings = 'djangoSettings';
  public static flaskProjectName = 'flaskProjectName';
  public static new = 'new';
  public static existing = 'existing';
  public static selectRepo = 'selectRepo';
  public static selectFolder = 'selectFolder';
  public static selectBranch = 'selectBranch';
  public static deployment = 'deployment';
  public static enableDeploymentSlot = 'enableDeploymentSlot';
  public static deploymentSlot = 'deploymentSlot';
  public static enterDSName = 'enterDSName';
  public static selectExistingSlot = 'selectExistingSlot';
  public static yes = 'yes';
  public static no = 'no';
  public static loadTesting = 'loadTesting';
  public static enableLoadTesting = 'enableLoadTesting';
  public static appName = 'appName';
  public static pricingTier = 'pricingTier';
  public static deploymentCenterTitle = 'deploymentCenterTitle';
  public static deploymentCenterDesc = 'deploymentCenterDesc';
  public static notAuthorized = 'notAuthorized';
  public static monitorHostFetchFailed = 'monitorHostFetchFailed';
  public static configureAppInsightsTitle = 'configureAppInsightsTitle';
  public static configureAppInsightsDesc = 'configureAppInsightsDesc';
  public static configureAppInsightsSwitchToClassic = 'configureAppInsightsSwitchToClassic';
  public static configureAppInsightsInstructions = 'configureAppInsightsInstructions';
  public static configureAppInsightsButton = 'configureAppInsightsButton';
  public static invocationTraces = 'invocationTraces';
  public static appInsightsDelay = 'appInsightsDelay';
  public static dragFileHereOr = 'dragFileHereOr';
  public static browse = 'browse';
  public static toUpload = 'toUpload';
  public static feature_metricsName = 'feature_metricsName';
  public static feature_metricsInfo = 'feature_metricsInfo';
  public static FTPMessage = 'FTPMessage';
  public static FTPLabel = 'FTPLabel';
  public static validating = 'validating';
  public static vstsReleaseBuildPermissions = 'vstsReleaseBuildPermissions';
  public static vstsAgentQueuePermissions = 'vstsAgentQueuePermissions';
  public static vstsCreateRepoPermissions = 'vstsCreateRepoPermissions';
  public static vstsPipelinesNotEnabled = 'vstsPipelinesNotEnabled';
  public static vstsNameUnavailable = 'vstsNameUnavailable';
  public static vstsTokenIsInvalid = 'vstsTokenIsInvalid';
  public static vstsTokenFetchFailed = 'vstsTokenFetchFailed';
  public static FTPBoth = 'FTPBoth';
  public static FTPSOnly = 'FTPSOnly';
  public static FTPDisable = 'FTPDisable';
  public static show = 'show';
  public static hide = 'hide';
  public static nomatchpassword = 'nomatchpassword';
  public static dashboard = 'dashboard';
  public static ftpDesc = 'ftpDesc';
  public static ftpInfoCardCredsDesc = 'ftpInfoCardCredsDesc';
  public static userCreds = 'userCreds';
  public static userCredsDesc = 'userCredsDesc';
  public static userCredsNewUserDesc = 'userCredsNewUserDesc';
  public static appCreds = 'appCreds';
  public static appCredsDesc = 'appCredsDesc';
  public static username = 'username';
  public static password = 'password';
  public static confirmPassword = 'confirmPassword';
  public static ftpsEndpoint = 'ftpsEndpoint';
  public static credentials = 'credentials';
  public static pending = 'pending';
  public static failed = 'failed';
  public static saveCredentials = 'saveCredentials';
  public static resetCredentials = 'resetCredentials';
  public static httpVersion = 'httpVersion';
  public static http20Proxy = 'http20Proxy';
  public static basicAuthPublishingCred = 'basicAuthPublishingCred';
  public static scmBasicAuthPublishingCredentials = 'scmBasicAuthPublishingCredentials';
  public static ftpBasicAuthPublishingCredentials = 'ftpBasicAuthPublishingCredentials';
  public static dismiss = 'dismiss';
  public static provider = 'provider';
  public static newAccount = 'newAccount';
  public static newDeploymentSlot = 'newDeploymentSlot';
  public static deploymentSlotName = 'deploymentSlotName';
  public static localGitRepoMessage = 'localGitRepoMessage';
  public static appFunctionSettings_functionAppSettings_badVersion = 'appFunctionSettings_functionAppSettings_badVersion';
  public static appFunctionSettings_warning_badVersionTitle = 'appFunctionSettings_warning_badVersionTitle';
  public static appFunctionSettings_warning_badVersionDescription = 'appFunctionSettings_warning_badVersionDescription';
  public static disconnect = 'disconnect';
  public static edit = 'edit';
  public static sync = 'sync';
  public static pricing_dv3SeriesComputeEquivalent = 'pricing_dv3SeriesComputeEquivalent';
  public static funcConnStringsInfoText = 'funcConnStringsInfoText';
  public static appFunctionSettings_functionAppSettings_versionLoading = 'appFunctionSettings_functionAppSettings_versionLoading';
  public static readOnlyLocalCache = 'readOnlyLocalCache';
  public static appSettingsHeader_delete = 'appSettingsHeader_delete';
  public static appSettingsHeader_value = 'appSettingsHeader_value';
  public static appSettingsHeader_isSlotSetting = 'appSettingsHeader_isSlotSetting';
  public static appSettingsHeader_appSettingName = 'appSettingsHeader_appSettingName';
  public static appSettingsHeader_connectionStringName = 'appSettingsHeader_connectionStringName';
  public static appSettingsHeader_type = 'appSettingsHeader_type';
  public static appSettingsHeader_documentName = 'appSettingsHeader_documentName';
  public static appSettingsHeader_extension = 'appSettingsHeader_extension';
  public static appSettingsHeader_scriptProcessor = 'appSettingsHeader_scriptProcessor';
  public static appSettingsHeader_arguments = 'appSettingsHeader_arguments';
  public static appSettingsHeader_virtualPath = 'appSettingsHeader_virtualPath';
  public static appSettingsHeader_physicalPath = 'appSettingsHeader_physicalPath';
  public static type_application = 'type_application';
  public static type_directory = 'type_directory';
  public static databaseAccount = 'databaseAccount';
  public static azureCosmosDB_account = 'azureCosmosDB_account';
  public static privateRepo = 'privateRepo';
  public static enterUsername = 'enterUsername';
  public static enterPassword = 'enterPassword';
  public static containerWriteAccessError = 'containerWriteAccessError';
  public static containerReadLockError = 'containerReadLockError';
  public static singleContainerTitle = 'singleContainerTitle';
  public static dockerComposeContainerTitle = 'dockerComposeContainerTitle';
  public static kubernetesContainerTitle = 'kubernetesContainerTitle';
  public static failedToInstallExtensionUrl = 'failedToInstallExtensionUrl';
  public static failedToInstallExtensionInstallId = 'failedToInstallExtensionInstallId';
  public static failedToInstallExtensionSessionId = 'failedToInstallExtensionSessionId';
  public static pricing_premiumContainerSharedDisk = 'pricing_premiumContainerSharedDisk';
  public static functionAppName = 'functionAppName';
  public static languageAria = 'languageAria';
  public static submitting = 'submitting';
  public static settingupDeployment = 'settingupDeployment';
  public static settingupDeploymentSuccess = 'settingupDeploymentSuccess';
  public static settingupDeploymentFail = 'settingupDeploymentFail';
  public static settingupDeploymentFailWithStatusMessage = 'settingupDeploymentFailWithStatusMessage';
  public static UpdatingPublishingUserFailWithStatusMessage = 'UpdatingPublishingUserFailWithStatusMessage';
  public static UpdatingPublishingUserFail = 'UpdatingPublishingUserFail';
  public static UpdatingPublishingUserSuccess = 'UpdatingPublishingUserSuccess';
  public static UpdatingPublishingUser = 'UpdatingPublishingUser';
  public static noPermissionsToCreateApp = 'noPermissionsToCreateApp';
  public static disconnectingDeployment = 'disconnectingDeployment';
  public static disconnectingDeploymentSuccess = 'disconnectingDeploymentSuccess';
  public static disconnectingDeploymentFail = 'disconnectingDeploymentFail';
  public static disconnectingDeploymentFailWithMessage = 'disconnectingDeploymentFailWithMessage';
  public static disconnectConfirm = 'disconnectConfirm';
  public static communityTemplatesTitle = 'communityTemplatesTitle';
  public static communityTemplatesDescription = 'communityTemplatesDescription';
  public static scmPingFailedErrorMessage = 'scmPingFailedErrorMessage';
  public static functionEditorCorsWarning = 'functionEditorCorsWarning';
  public static scmPingFailedLearnMore = 'scmPingFailedLearnMore';
  public static extensionInstallDocLink = 'extensionInstallDocLink';
  public static pricing_ACU = 'pricing_ACU';
  public static containerSettingsApplyLabel = 'containerSettingsApplyLabel';
  public static containerQuickstart = 'containerQuickstart';
  public static containerACR = 'containerACR';
  public static containerDockerHub = 'containerDockerHub';
  public static containerPrivateRegistry = 'containerPrivateRegistry';
  public static containerCustom = 'containerCustom';
  public static containerImageSource = 'containerImageSource';
  public static containerImageAndTag = 'containerImageAndTag';
  public static containerImageAndTagPlaceholder = 'containerImageAndTagPlaceholder';
  public static containerImageAndTagPlaceholderForWindows = 'containerImageAndTagPlaceholderForWindows';
  public static containerACRMissingErrorMessage = 'containerACRMissingErrorMessage';
  public static containerRepositoryAccess = 'containerRepositoryAccess';
  public static containerRepositoryPublic = 'containerRepositoryPublic';
  public static containerRepositoryPrivate = 'containerRepositoryPrivate';
  public static containerServerURL = 'containerServerURL';
  public static containerServerURLPlaceholder = 'containerServerURLPlaceholder';
  public static containerLogin = 'containerLogin';
  public static containerPassword = 'containerPassword';
  public static containerStartupFileOrCommand = 'containerStartupFileOrCommand';
  public static containerConfigurationSource = 'containerConfigurationSource';
  public static containerConfiguration = 'containerConfiguration';
  public static quickstartDotnetTitle = 'quickstartDotnetTitle';
  public static quickstartNodeTitle = 'quickstartNodeTitle';
  public static quickstartPythonTitle = 'quickstartPythonTitle';
  public static quickstartJavaTitle = 'quickstartJavaTitle';
  public static quickstartDescription = 'quickstartDescription';
  public static chooseDevEnvironment = 'chooseDevEnvironment';
  public static chooseDeploymentMethod = 'chooseDeploymentMethod';
  public static createFunction = 'createFunction';
  public static quickstart = 'quickstart';
  public static vsCardTitle = 'vsCardTitle';
  public static vscodeCardTitle = 'vscodeCardTitle';
  public static coretoolsCardTitle = 'coretoolsCardTitle';
  public static mavenCardTitle = 'mavenCardTitle';
  public static portalCardTitle = 'portalCardTitle';
  public static vsCardDescription = 'vsCardDescription';
  public static vscodeCardDescription = 'vscodeCardDescription';
  public static coretoolsCardDescription = 'coretoolsCardDescription';
  public static mavenCardDescription = 'mavenCardDescription';
  public static portalCardDescription = 'portalCardDescription';
  public static deploymentCenterCardTitle = 'deploymentCenterCardTitle';
  public static deploymentCenterCardDescription = 'deploymentCenterCardDescription';
  public static directPublishCardTitle = 'directPublishCardTitle';
  public static vsDirectPublishCardDescription = 'vsDirectPublishCardDescription';
  public static vscodeDirectPublishCardDescription = 'vscodeDirectPublishCardDescription';
  public static coretoolsDirectPublishCardDescription = 'coretoolsDirectPublishCardDescription';
  public static mavenDirectPublishCardDescription = 'mavenDirectPublishCardDescription';
  public static httpCardDescription = 'httpCardDescription';
  public static timerCardDescription = 'timerCardDescription';
  public static quickstartMessage1 = 'quickstartMessage1';
  public static quickstartMessage2 = 'quickstartMessage2';
  public static syncRequestSubmitted = 'syncRequestSubmitted';
  public static syncRequestSubmittedDesc = 'syncRequestSubmittedDesc';
  public static syncRequestSubmittedDescFail = 'syncRequestSubmittedDescFail';
  public static vsts_permissions_error = 'vsts_permissions_error';
  public static quickstartSelectSample = 'quickstartSelectSample';
  public static quickStartSampleDescription = 'quickStartSampleDescription';
  public static no_vsts_repos = 'no_vsts_repos';
  public static no_vsts_accounts = 'no_vsts_accounts';
  public static no_vsts_accounts_kudu = 'no_vsts_accounts_kudu';
  public static create_one = 'create_one';
  public static topBar_updateExtensions = 'topBar_updateExtensions';
  public static cloneConfigLoadFailure = 'cloneConfigLoadFailure';
  public static noCreateAccess = 'noCreateAccess';
  public static noSwapPermission = 'noSwapPermission';
  public static noWritePermission = 'noWritePermission';
  public static slotReadOnlyLock = 'slotReadOnlyLock';
  public static swapSrcDestNotUnique = 'swapSrcDestNotUnique';
  public static swapMultiPhasePermissionsFailure = 'swapMultiPhasePermissionsFailure';
  public static swapMultiPhaseAuthConflict = 'swapMultiPhaseAuthConflict';
  public static swapMultiPhaseNoStickySettings = 'swapMultiPhaseNoStickySettings';
  public static swapMultiPhasePreviewMessage = 'swapMultiPhasePreviewMessage';
  public static noWritePermissionOnSlots = 'noWritePermissionOnSlots';
  public static noSwapPermissionOnSlots = 'noSwapPermissionOnSlots';
  public static readOnlyLockOnSlots = 'readOnlyLockOnSlots';
  public static swapRequresMultipleSlots = 'swapRequresMultipleSlots';
  public static swapSlotsHeading = 'swapSlotsHeading';
  public static swapLoadingFailed = 'swapLoadingFailed';
  public static phaseOneChangesHeading = 'phaseOneChangesHeading';
  public static phaseTwoChangesHeading = 'phaseTwoChangesHeading';
  public static swapDiffHeading = 'swapDiffHeading';
  public static phaseOneChangesInfoText = 'phaseOneChangesInfoText';
  public static swapChangesInfoText = 'swapChangesInfoText';
  public static swapPreviewMakeSelection = 'swapPreviewMakeSelection';
  public static swapChangesLoadingFailed = 'swapChangesLoadingFailed';
  public static swapSourceChangesHeading = 'swapSourceChangesHeading';
  public static swapTargetChangesHeading = 'swapTargetChangesHeading';
  public static swapActionLabel = 'swapActionLabel';
  public static frameworkVersion = 'frameworkVersion';
  public static startupCommand = 'startupCommand';
  public static pathToApplicationCode = 'pathToApplicationCode';
  public static preview = 'preview';
  public static swapDiffsNoChange = 'swapDiffsNoChange';
  public static swapDiffNotSet = 'swapDiffNotSet';
  public static extensionUninstallError = 'extensionUninstallError';
  public static v2_preview_label = 'v2_preview_label';
  public static functionAppRuntimeStackTitle = 'functionAppRuntimeStackTitle';
  public static functionAppRuntimeStackDescription = 'functionAppRuntimeStackDescription';
  public static functionRuntimeStackLabel = 'functionRuntimeStackLabel';
  public static Go = 'Go';
  public static containerACRRegistry = 'containerACRRegistry';
  public static containerACRImage = 'containerACRImage';
  public static containerACRTag = 'containerACRTag';
  public static containerImageName = 'containerImageName';
  public static containerImageNamePlaceHolder = 'containerImageNamePlaceHolder';
  public static containerGitHubActionsTagLabel = 'containerGitHubActionsTagLabel';
  public static containerACRStartupFile = 'containerACRStartupFile';
  public static containerContinuousDeployment = 'containerContinuousDeployment';
  public static containerWebhookUrl = 'containerWebhookUrl';
  public static containerMultiConfiguration = 'containerMultiConfiguration';
  public static containerMultiConfigurationFile = 'containerMultiConfigurationFile';
  public static windowsDockerComposeDisableMessage = 'windowsDockerComposeDisableMessage';
  public static windowsKubernetesDisableMessage = 'windowsKubernetesDisableMessage';
  public static functionsDockerComposeDisableMessage = 'functionsDockerComposeDisableMessage';
  public static functionsKubernetesDisableMessage = 'functionsKubernetesDisableMessage';
  public static readOnlyBYOC = 'readOnlyBYOC';
  public static failedToGetContainerConfigData = 'failedToGetContainerConfigData';
  public static invalidUrl = 'invalidUrl';
  public static failedToUpdateContainerConfigData = 'failedToUpdateContainerConfigData';
  public static errorsInContainerSettings = 'errorsInContainerSettings';
  public static containerSettingsUpdateSuccess = 'containerSettingsUpdateSuccess';
  public static showUrl = 'showUrl';
  public static hideUrl = 'hideUrl';
  public static formIsInvalid = 'formIsInvalid';
  public static finishAndDeploy = 'finishAndDeploy';
  public static readOnlyLinuxDynamic = 'readOnlyLinuxDynamic';
  public static readOnlyLinuxCodeElastic = 'readOnlyLinuxCodeElastic';
  public static moreTemplatesTitle = 'moreTemplatesTitle';
  public static moreTemplatesDescription = 'moreTemplatesDescription';
  public static moreTemplatesButton = 'moreTemplatesButton';
  public static singleContainerSample1TitleLinux = 'singleContainerSample1TitleLinux';
  public static singleContainerSample1DescriptionLinux = 'singleContainerSample1DescriptionLinux';
  public static singleContainerSample2TitleLinux = 'singleContainerSample2TitleLinux';
  public static singleContainerSample2DescriptionLinux = 'singleContainerSample2DescriptionLinux';
  public static singleContainerSample3TitleLinux = 'singleContainerSample3TitleLinux';
  public static singleContainerSample3DescriptionLinux = 'singleContainerSample3DescriptionLinux';
  public static singleContainerSample1TitleWindows = 'singleContainerSample1TitleWindows';
  public static singleContainerSample1DescriptionWindows = 'singleContainerSample1DescriptionWindows';
  public static dockerComposeSample1TitleLinux = 'dockerComposeSample1TitleLinux';
  public static dockerComposeSample1DescriptionLinux = 'dockerComposeSample1DescriptionLinux';
  public static dockerComposeSample2TitleLinux = 'dockerComposeSample2TitleLinux';
  public static dockerComposeSample2DescriptionLinux = 'dockerComposeSample2DescriptionLinux';
  public static dockerComposeSample3TitleLinux = 'dockerComposeSample3TitleLinux';
  public static dockerComposeSample3DescriptionLinux = 'dockerComposeSample3DescriptionLinux';
  public static kubernetesSample1TitleLinux = 'kubernetesSample1TitleLinux';
  public static kubernetesSample1DescriptionLinux = 'kubernetesSample1DescriptionLinux';
  public static kubernetesSample2TitleLinux = 'kubernetesSample2TitleLinux';
  public static kubernetesSample2DescriptionLinux = 'kubernetesSample2DescriptionLinux';
  public static noLogsAvailable = 'noLogsAvailable';
  public static errorRetrievingLogs = 'errorRetrievingLogs';
  public static newOrExistingDeploymentSlot = 'newOrExistingDeploymentSlot';
  public static newOrExistingVstsAccount = 'newOrExistingVstsAccount';
  public static newOrExistingWebApp = 'newOrExistingWebApp';
  public static deploymentDetails = 'deploymentDetails';
  public static installingExtensionIntegrate = 'installingExtensionIntegrate';
  public static hideValues = 'hideValues';
  public static showValues = 'showValues';
  public static hiddenValueClickToEdit = 'hiddenValueClickToEdit';
  public static appSettingsEncryptedInfoText = 'appSettingsEncryptedInfoText';
  public static connectionStringsEncryptedInfoText = 'connectionStringsEncryptedInfoText';
  public static team = 'team';
  public static personal = 'personal';
  public static swaggerDefinitionReadOnly = 'swaggerDefinitionReadOnly';
  public static troubleshootYourApp = 'troubleshootYourApp';
  public static diagnoseAndSolveProblems = 'diagnoseAndSolveProblems';
  public static stackSettings = 'stackSettings';
  public static platformSettings = 'platformSettings';
  public static functionsAdminIsolation = 'functionsAdminIsolation';
  public static functionsAdminIsolationInfoBubble = 'functionsAdminIsolationInfoBubble';
  public static debugging = 'debugging';
  public static modifiedTag = 'modifiedTag';
  public static directToEnvironmentVariablesInfoMessage = 'directToEnvironmentVariablesInfoMessage';
  public static directToEnvironmentVariablesLink = 'directToEnvironmentVariablesLink';
  public static applicationSettings = 'applicationSettings';
  public static functionRuntimeSettings = 'functionRuntimeSettings';
  public static generalSettings = 'generalSettings';
  public static defaultDocuments = 'defaultDocuments';
  public static customErrorPage = 'customErrorPage';
  public static ErrorPagesGrid = 'ErrorPagesGrid';
  public static ErrorPagesAlwaysUse = 'ErrorPagesAlwaysUse';
  public static ErrorPagesAlwaysUseTooltip = 'ErrorPagesAlwaysUseTooltip';
  public static ErrorPagesGridNotAvailable = 'ErrorPagesGridNotAvailable';
  public static errorPage = 'errorPage';
  public static pathMappings = 'pathMappings';
  public static errorPage_columnErrorCode = 'errorPage_columnErrorCode';
  public static errorPage_columnStatus = 'errorPage_columnStatus';
  public static errorPage_columnStatus_configured = 'errorPage_columnStatus_configured';
  public static errorPage_columnStatus_notConfigured = 'errorPage_columnStatus_notConfigured';
  public static handlerMappings = 'handlerMappings';
  public static virtualApplications = 'virtualApplications';
  public static appSettingsSaveAriaLabel = 'appSettingsSaveAriaLabel';
  public static appSettingsDiscardAriaLabel = 'appSettingsDiscardAriaLabel';
  public static appSettingsCommandBarAriaLabel = 'appSettingsCommandBarAriaLabel';
  public static newApp = 'newApp';
  public static addErrorPage = 'addErrorPage';
  public static editErrorPage = 'editErrorPage';
  public static virtualPath = 'virtualPath';
  public static physicalPath = 'physicalPath';
  public static type = 'type';
  public static delete = 'delete';
  public static remove = 'remove';
  public static directoryOrApplciation = 'directoryOrApplciation';
  public static directory = 'directory';
  public static application = 'application';
  public static preloadEnabled = 'preloadEnabled';
  public static extension = 'extension';
  public static scriptProcessor = 'scriptProcessor';
  public static argumentsRes = 'argumentsRes';
  public static newHandlerMapping = 'newHandlerMapping';
  public static stack = 'stack';
  public static stackInfoMessage = 'stackInfoMessage';
  public static slots = 'slots';
  public static autoSwapEnabled = 'autoSwapEnabled';
  public static autoSwapSlot = 'autoSwapSlot';
  public static platform = 'platform';
  public static managedPipelineVersion = 'managedPipelineVersion';
  public static integrated = 'integrated';
  public static classic = 'classic';
  public static ftpState = 'ftpState';
  public static allAllowed = 'allAllowed';
  public static ftpsOnly = 'ftpsOnly';
  public static alwaysOn = 'alwaysOn';
  public static latestMinorVersion = 'latestMinorVersion';
  public static phpVersion = 'phpVersion';
  public static javaMinorVersion = 'javaMinorVersion';
  public static javaContainer = 'javaContainer';
  public static javaContainerVersion = 'javaContainerVersion';
  public static newDocument = 'newDocument';
  public static nameRes = 'nameRes';
  public static value = 'value';
  public static sticky = 'sticky';
  public static newApplicationSetting = 'newApplicationSetting';
  public static addEditConnectionStringHeader = 'addEditConnectionStringHeader';
  public static newConnectionString = 'newConnectionString';
  public static addEditApplicationSetting = 'addEditApplicationSetting';
  public static containerACRCrossSubscriptionRegistry = 'containerACRCrossSubscriptionRegistry';
  public static sideNav_Functions_ReadOnly = 'sideNav_Functions_ReadOnly';
  public static sideNav_FunctionsInaccessible = 'sideNav_FunctionsInaccessible';
  public static sideNav_ProxiesReadOnly = 'sideNav_ProxiesReadOnly';
  public static sideNav_ProxiesInaccessible = 'sideNav_ProxiesInaccessible';
  public static configYamlInvalid = 'configYamlInvalid';
  public static detailContainerLogFetchTitle = 'detailContainerLogFetchTitle';
  public static detailContainerLogFetchDescription = 'detailContainerLogFetchDescription';
  public static detailContainerLogFetchSuccess = 'detailContainerLogFetchSuccess';
  public static detailContainerLogFetchFailure = 'detailContainerLogFetchFailure';
  public static resettingCredentials = 'resettingCredentials';
  public static resettingCredentialsFail = 'resettingCredentialsFail';
  public static resettingCredentialsSuccess = 'resettingCredentialsSuccess';
  public static savingCredentials = 'savingCredentials';
  public static savingCredentialsFail = 'savingCredentialsFail';
  public static savingCredentialsSuccess = 'savingCredentialsSuccess';
  public static containerPrivateRegistryDescription = 'containerPrivateRegistryDescription';
  public static notSelected = 'notSelected';
  public static autoUpdate = 'autoUpdate';
  public static versionAutoUpdate = 'versionAutoUpdate';
  public static functionsJavaMajorVersionWarning = 'functionsJavaMajorVersionWarning';
  public static functionsJavaMinorVersionWarning = 'functionsJavaMinorVersionWarning';
  public static quickstartPowershellTitle = 'quickstartPowershellTitle';
  public static addStorageTitle = 'addStorageTitle';
  public static addStorageDescription = 'addStorageDescription';
  public static configurationOption = 'configurationOption';
  public static basic = 'basic';
  public static advanced = 'advanced';
  public static chooseAccount = 'chooseAccount';
  public static storageAccount = 'storageAccount';
  public static storageContainer = 'storageContainer';
  public static storageFileShare = 'storageFileShare';
  public static blob = 'blob';
  public static files = 'files';
  public static chooseContainer = 'chooseContainer';
  public static mountPath = 'mountPath';
  public static shareName = 'shareName';
  public static shareNameInfoBubbleMessage = 'shareNameInfoBubbleMessage';
  public static accessKey = 'accessKey';
  public static chooseFileShare = 'chooseFileShare';
  public static storageType = 'storageType';
  public static invalidWindowsPath = 'invalidWindowsPath';
  public static invalidLinuxPath = 'invalidLinuxPath';
  public static mountStorage = 'mountStorage';
  public static addStorageLink = 'addStorageLink';
  public static container = 'container';
  public static path = 'path';
  public static storageKeysHiddenInfoText = 'storageKeysHiddenInfoText';
  public static storageAccounts = 'storageAccounts';
  public static storageAccountName = 'storageAccountName';
  public static ok = 'ok';
  public static invalidShare = 'invalidShare';
  public static invalidCredentials = 'invalidCredentials';
  public static emptyStorageAccounts = 'emptyStorageAccounts';
  public static byos_storageNameExists = 'byos_storageNameExists';
  public static byos_storageAccountInfoMessage = 'byos_storageAccountInfoMessage';
  public static unableToReachBuild = 'unableToReachBuild';
  public static invalidWindowsPathCdrive = 'invalidWindowsPathCdrive';
  public static limitedMode = 'limitedMode';
  public static limited = 'limited';
  public static sideNav_FunctionsLimited = 'sideNav_FunctionsLimited';
  public static stoppedMode = 'stoppedMode';
  public static noAccessMode = 'noAccessMode';
  public static readOnlyMode = 'readOnlyMode';
  public static nonReachableMode = 'nonReachableMode';
  public static sideNav_ProxiesLimited = 'sideNav_ProxiesLimited';
  public static slotSettingNoProdPermission = 'slotSettingNoProdPermission';
  public static autoSwapSettingPermissionFail = 'autoSwapSettingPermissionFail';
  public static scriptFunctionApp = 'scriptFunctionApp';
  public static precompiledDotNetApp = 'precompiledDotNetApp';
  public static functionAppType = 'functionAppType';
  public static slotSettingOn = 'slotSettingOn';
  public static hiddenValueClickAboveToShow = 'hiddenValueClickAboveToShow';
  public static fieldMustBeUnique = 'fieldMustBeUnique';
  public static addNewVirtualDirectoryV3 = 'addNewVirtualDirectoryV3';
  public static addNewHandler = 'addNewHandler';
  public static feature_logStreamingConnectionError = 'feature_logStreamingConnectionError';
  public static applicationSettingsNoPermission = 'applicationSettingsNoPermission';
  public static connectionStringsNoPermissions = 'connectionStringsNoPermissions';
  public static tab_logicAppsDeprecation = 'tab_logicAppsDeprecation';
  public static diagnosticLogsDisabled = 'diagnosticLogsDisabled';
  public static scaleOut = 'scaleOut';
  public static scaleOutDescription = 'scaleOutDescription';
  public static accountName = 'accountName';
  public static azureBlob = 'azureBlob';
  public static azureFiles = 'azureFiles';
  public static newAzureStorageMount = 'newAzureStorageMount';
  public static editAzureStorageMount = 'editAzureStorageMount';
  public static emptyAzureStorageMount = 'emptyAzureStorageMount';
  public static azureStorageMountMustBeUnique = 'azureStorageMountMustBeUnique';
  public static virtualPathUnique = 'virtualPathUnique';
  public static storageAccessLabel = 'storageAccessLabel';
  public static protocolLabel = 'protocolLabel';
  public static manualInput = 'manualInput';
  public static keyVaultReference = 'keyVaultReference';
  public static configurationOptions = 'configurationOptions';
  public static storageAccountNameMustBeLowerCase = 'storageAccountNameMustBeLowerCase';
  public static noBlobsOrFilesShares = 'noBlobsOrFilesShares';
  public static noFileShares = 'noFileShares';
  public static noBlobs = 'noBlobs';
  public static noWriteAccessStorageAccount = 'noWriteAccessStorageAccount';
  public static selectAnOption = 'selectAnOption';
  public static invalidStartupCommandNodejs = 'invalidStartupCommandNodejs';
  public static invalidStartupCommandAspNetCore = 'invalidStartupCommandAspNetCore';
  public static storageMountsNoPermissions = 'storageMountsNoPermissions';
  public static readOnlyPython = 'readOnlyPython';
  public static slotSettingMustBeBoolean = 'slotSettingMustBeBoolean';
  public static appSettingValuesMustBeAnArray = 'appSettingValuesMustBeAnArray';
  public static appSettingPropIsRequired = 'appSettingPropIsRequired';
  public static appSettingValueMustBeAString = 'appSettingValueMustBeAString';
  public static appSettingInvalidProperty = 'appSettingInvalidProperty';
  public static appSettingNamesUnique = 'appSettingNamesUnique';
  public static connectionStringValuesMustBeAnArray = 'connectionStringValuesMustBeAnArray';
  public static connectionStringPropIsRequired = 'connectionStringPropIsRequired';
  public static connectionStringValueMustBeAString = 'connectionStringValueMustBeAString';
  public static connectionStringInvalidProperty = 'connectionStringInvalidProperty';
  public static connectionStringNamesUnique = 'connectionStringNamesUnique';
  public static slotSettingForbiddenProperty = 'slotSettingForbiddenProperty';
  public static handlerMappingPropIsRequired = 'handlerMappingPropIsRequired';
  public static jsonInvalid = 'jsonInvalid';
  public static advancedEdit = 'advancedEdit';
  public static coachMarkAriaDescription = 'coachMarkAriaDescription';
  public static aCoachmarkHasAppearedAriaAlert = 'aCoachmarkHasAppearedAriaAlert';
  public static advancedEditCoachmarkDesc = 'advancedEditCoachmarkDesc';
  public static physicalPathLocationError = 'physicalPathLocationError';
  public static virtualDirectoryPathError = 'virtualDirectoryPathError';
  public static logStreamingApplicationLogsDisabled = 'logStreamingApplicationLogsDisabled';
  public static logStreamingWebServerLogsDisabled = 'logStreamingWebServerLogsDisabled';
  public static remoteDebuggingNotAvailableForRuntimeStack = 'remoteDebuggingNotAvailableForRuntimeStack';
  public static appSettingsUpsellBannerMessage = 'appSettingsUpsellBannerMessage';
  public static customErrorPageUpsellBannerMessage = 'customErrorPageUpsellBannerMessage';
  public static appInsightsNotConfigured = 'appInsightsNotConfigured';
  public static ipRestrictionsWarning = 'ipRestrictionsWarning';
  public static userCredsError = 'userCredsError';
  public static incomingClientCertificates = 'incomingClientCertificates';
  public static requireIncomingClientCertificates = 'requireIncomingClientCertificates';
  public static clientCertificateMode = 'clientCertificateMode';
  public static clientCertificateModeRequire = 'clientCertificateModeRequire';
  public static clientCertificateModeAllow = 'clientCertificateModeAllow';
  public static clientCertificateModeOptional = 'clientCertificateModeOptional';
  public static clientCertificateModeIgnore = 'clientCertificateModeIgnore';
  public static clientCertificateModeRequiredInfoBubbleMessage = 'clientCertificateModeRequiredInfoBubbleMessage';
  public static clientCertificateModeAllowInfoBubbleMessage = 'clientCertificateModeAllowInfoBubbleMessage';
  public static clientCertificateModeOptionalInfoBubbleMessage = 'clientCertificateModeOptionalInfoBubbleMessage';
  public static clientCertificateModeIgnoreInfoBubbleMessage = 'clientCertificateModeIgnoreInfoBubbleMessage';
  public static certificateExlusionPaths = 'certificateExlusionPaths';
  public static editCertificateExlusionPaths = 'editCertificateExlusionPaths';
  public static noExclusionRulesDefined = 'noExclusionRulesDefined';
  public static newPath = 'newPath';
  public static githubOrgMessage = 'githubOrgMessage';
  public static projectWithoutGitRepoNotFoundMessage = 'projectWithoutGitRepoNotFoundMessage';
  public static bitbucketOrgMessage = 'bitbucketOrgMessage';
  public static useIncomingClientCertsUpsell = 'useIncomingClientCertsUpsell';
  public static clientCertWarning = 'clientCertWarning';
  public static alwaysOnInfoMessage = 'alwaysOnInfoMessage';
  public static ftpsInfoMessage = 'ftpsInfoMessage';
  public static arrAffinityInfoMessage = 'arrAffinityInfoMessage';
  public static applicationSettingsInfoMessage = 'applicationSettingsInfoMessage';
  public static connectionStringsInfoMessage = 'connectionStringsInfoMessage';
  public static powershellPreview = 'powershellPreview';
  public static filter = 'filter';
  public static filterAppSettings = 'filterAppSettings';
  public static gridItemsCountAriaLabel = 'gridItemsCountAriaLabel';
  public static gridItemsCountAriaLabelNoFilter = 'gridItemsCountAriaLabelNoFilter';
  public static gridItemsCountAriaLabelNoResults = 'gridItemsCountAriaLabelNoResults';
  public static gridItemsCountAriaLabelNoFilterNoResults = 'gridItemsCountAriaLabelNoFilterNoResults';
  public static result = 'result';
  public static results = 'results';
  public static filterConnectionStrings = 'filterConnectionStrings';
  public static readOnlyJava = 'readOnlyJava';
  public static validate_workingDirectory = 'validate_workingDirectory';
  public static mountedStorageInfo = 'mountedStorageInfo';
  public static changePlanName = 'changePlanName';
  public static changePlanDescription = 'changePlanDescription';
  public static changePlanLocationTooltip = 'changePlanLocationTooltip';
  public static changePlanCurrentPlanDetails = 'changePlanCurrentPlanDetails';
  public static changePlanDestPlanDetails = 'changePlanDestPlanDetails';
  public static changePlanNotification = 'changePlanNotification';
  public static changePlanFailureNotificationFormat = 'changePlanFailureNotificationFormat';
  public static changePlanRgCreateFailureNotificationFormat = 'changePlanRgCreateFailureNotificationFormat';
  public static changePlanPlanCreateFailureNotificationFormat = 'changePlanPlanCreateFailureNotificationFormat';
  public static changePlanNoWritePermissionRg = 'changePlanNoWritePermissionRg';
  public static changePlanSiteLockedError = 'changePlanSiteLockedError';
  public static changePlanNoWritePermissionOnSubscription = 'changePlanNoWritePermissionOnSubscription';
  public static resourceGroupNameValidationError = 'resourceGroupNameValidationError';
  public static aspNameCharacterValidationError = 'aspNameCharacterValidationError';
  public static aspNameRestrictedValidationError = 'aspNameRestrictedValidationError';
  public static aspNameLengthValidationError = 'aspNameLengthValidationError';
  public static aspNameConflictValidationError = 'aspNameConflictValidationError';
  public static cancelUpdateConfirmation = 'cancelUpdateConfirmation';
  public static newFormat = 'newFormat';
  public static validationErrorAlreadyExistsFormat = 'validationErrorAlreadyExistsFormat';
  public static validationWebspaceUniqueErrorFormat = 'validationWebspaceUniqueErrorFormat';
  public static resourceGroupDescription = 'resourceGroupDescription';
  public static createNewPlan = 'createNewPlan';
  public static planName = 'planName';
  public static majorVersion = 'majorVersion';
  public static minorVersion = 'minorVersion';
  public static containerValidationFailed = 'containerValidationFailed';
  public static integrateNoTriggerDefined = 'integrateNoTriggerDefined';
  public static integrateNoInputsDefined = 'integrateNoInputsDefined';
  public static integrateNoOutputsDefined = 'integrateNoOutputsDefined';
  public static integrateAddTrigger = 'integrateAddTrigger';
  public static integrateCreateTrigger = 'integrateCreateTrigger';
  public static integrateAddInput = 'integrateAddInput';
  public static integrateCreateInput = 'integrateCreateInput';
  public static integrateCreateInputBindingInstructions = 'integrateCreateInputBindingInstructions';
  public static integrateCreateOutputBindingInstructions = 'integrateCreateOutputBindingInstructions';
  public static integrateCreateTriggerBindingInstructions = 'integrateCreateTriggerBindingInstructions';
  public static integrateBindingType = 'integrateBindingType';
  public static integrateCreateBindingTypeDetails = 'integrateCreateBindingTypeDetails';
  public static integratePageTitle = 'integratePageTitle';
  public static integratePageDescription = 'integratePageDescription';
  public static _function = '_function';
  public static fetchingDeploymentData = 'fetchingDeploymentData';
  public static noDeploymentDataAvailable = 'noDeploymentDataAvailable';
  public static featureNotSupportedForILBASEApps = 'featureNotSupportedForILBASEApps';
  public static azureReposLabel = 'azureReposLabel';
  public static updateBindingNotification = 'updateBindingNotification';
  public static updateBindingNotificationDetails = 'updateBindingNotificationDetails';
  public static updateBindingNotificationFailed = 'updateBindingNotificationFailed';
  public static updateBindingNotificationSuccess = 'updateBindingNotificationSuccess';
  public static editBindingInput = 'editBindingInput';
  public static editBindingOutput = 'editBindingOutput';
  public static editBindingTrigger = 'editBindingTrigger';
  public static editBindingCommands = 'editBindingCommands';
  public static functionCreate_newFunction = 'functionCreate_newFunction';
  public static functionCreate_createFunctionMessage = 'functionCreate_createFunctionMessage';
  public static functionCreate_templates = 'functionCreate_templates';
  public static functionCreate_details = 'functionCreate_details';
  public static functionCreate_searchByTemplateName = 'functionCreate_searchByTemplateName';
  public static functionCreate_createFunction = 'functionCreate_createFunction';
  public static appSettingsRefreshAriaLabel = 'appSettingsRefreshAriaLabel';
  public static keyVaultReferenceDetails = 'keyVaultReferenceDetails';
  public static appConfigurationReferenceDetails = 'appConfigurationReferenceDetails';
  public static keyVaultName = 'keyVaultName';
  public static keyVaultSecretName = 'keyVaultSecretName';
  public static keyVaultSecretVersion = 'keyVaultSecretVersion';
  public static identity = 'identity';
  public static errorDetails = 'errorDetails';
  public static appKeysHost = 'appKeysHost';
  public static appKeysSystem = 'appKeysSystem';
  public static addHostKey = 'addHostKey';
  public static editHostKey = 'editHostKey';
  public static newHostKey = 'newHostKey';
  public static addSystemKey = 'addSystemKey';
  public static editSystemKey = 'editSystemKey';
  public static newSystemKey = 'newSystemKey';
  public static emptyHostKeys = 'emptyHostKeys';
  public static emptySystemKeys = 'emptySystemKeys';
  public static filterHostKeys = 'filterHostKeys';
  public static filterSystemKeys = 'filterSystemKeys';
  public static appKeyPropIsRequired = 'appKeyPropIsRequired';
  public static appKeyNamesUnique = 'appKeyNamesUnique';
  public static enterAppKeyName = 'enterAppKeyName';
  public static defaultValueAppKey = 'defaultValueAppKey';
  public static renewAppKey = 'renewAppKey';
  public static continousDeploymentSectionTitle = 'continousDeploymentSectionTitle';
  public static manualDeploymentSectionTitle = 'manualDeploymentSectionTitle';
  public static renewKeyValue = 'renewKeyValue';
  public static renewKeyValueContent = 'renewKeyValueContent';
  public static apimUpsell = 'apimUpsell';
  public static sourceControlAuthStateFailure = 'sourceControlAuthStateFailure';
  public static functionKeysRefreshAriaLabel = 'functionKeysRefreshAriaLabel';
  public static functionKeysCommandBarAriaLabel = 'functionKeysCommandBarAriaLabel';
  public static newFunctionKey = 'newFunctionKey';
  public static filterFunctionKeys = 'filterFunctionKeys';
  public static editFunctionKey = 'editFunctionKey';
  public static addFunctionKey = 'addFunctionKey';
  public static functionKeyPropIsRequired = 'functionKeyPropIsRequired';
  public static functionKeyNamesUnique = 'functionKeyNamesUnique';
  public static gitHubActionBuildServerDesc = 'gitHubActionBuildServerDesc';
  public static azureKeyVault = 'azureKeyVault';
  public static azureKeyVaultRefResolved = 'azureKeyVaultRefResolved';
  public static azureKeyVaultRefNotResolved = 'azureKeyVaultRefNotResolved';
  public static azureAppServiceValue = 'azureAppServiceValue';
  public static azureAppConfigRefValue = 'azureAppConfigRefValue';
  public static azureAppConfigRefAriaLabelResolved = 'azureAppConfigRefAriaLabelResolved';
  public static azureAppConfigRefAriaLabelNotResolved = 'azureAppConfigRefAriaLabelNotResolved';
  public static appSettingKeyvaultAPIError = 'appSettingKeyvaultAPIError';
  public static containerSettingsNotConfigured = 'containerSettingsNotConfigured';
  public static containerSettingsTitle = 'containerSettingsTitle';
  public static feature_containerSettingsInfo = 'feature_containerSettingsInfo';
  public static linux = 'linux';
  public static deploymentCredentialsTitle = 'deploymentCredentialsTitle';
  public static deploymentCredentialsDescription = 'deploymentCredentialsDescription';
  public static deploymentCredentialsLocalGit = 'deploymentCredentialsLocalGit';
  public static deploymentCredentialsFtps = 'deploymentCredentialsFtps';
  public static none = 'none';
  public static functionEditorSaveAriaLabel = 'functionEditorSaveAriaLabel';
  public static functionEditorDiscardAriaLabel = 'functionEditorDiscardAriaLabel';
  public static functionEditorTestAriaLabel = 'functionEditorTestAriaLabel';
  public static functionEditorGetFunctionUrlAriaLabel = 'functionEditorGetFunctionUrlAriaLabel';
  public static functionEditorCommandBarAriaLabel = 'functionEditorCommandBarAriaLabel';
  public static localGitDescription = 'localGitDescription';
  public static ftpsDescription = 'ftpsDescription';
  public static gitCloneUrlLabel = 'gitCloneUrlLabel';
  public static githubActionWorkflowConfiguration = 'githubActionWorkflowConfiguration';
  public static githubActionSavingSettings = 'githubActionSavingSettings';
  public static githubActionSettingsSavedSuccessfully = 'githubActionSettingsSavedSuccessfully';
  public static githubActionWorkflowCommitMessage = 'githubActionWorkflowCommitMessage';
  public static functionAppDirectoryDropdownAriaLabel = 'functionAppDirectoryDropdownAriaLabel';
  public static functionDirectoryDropdownAriaLabel = 'functionDirectoryDropdownAriaLabel';
  public static noPlanWritePermissions = 'noPlanWritePermissions';
  public static closeGetFunctionUrlModal = 'closeGetFunctionUrlModal';
  public static validation_linuxConnectionStringNameError = 'validation_linuxConnectionStringNameError';
  public static scope = 'scope';
  public static appFunctionSettings_virtualNetworkTriggerSupport = 'appFunctionSettings_virtualNetworkTriggerSupport';
  public static appFunctionSettings_runtimeScalingMonitoredText = 'appFunctionSettings_runtimeScalingMonitoredText';
  public static appFunctionSettings_runtimeScalingMonitoringMessage = 'appFunctionSettings_runtimeScalingMonitoringMessage';
  public static refreshAppSettingsTitle = 'refreshAppSettingsTitle';
  public static refreshAppSettingsMessage = 'refreshAppSettingsMessage';
  public static eventHubPicker_noNamespaces = 'eventHubPicker_noNamespaces';
  public static eventHubCallout_newEventHubConnection = 'eventHubCallout_newEventHubConnection';
  public static eventHubPicker_noEventHubs = 'eventHubPicker_noEventHubs';
  public static eventHubPicker_noPolicies = 'eventHubPicker_noPolicies';
  public static iotHubPivot_noIoTHubs = 'iotHubPivot_noIoTHubs';
  public static iotHubPivot_IoTHub = 'iotHubPivot_IoTHub';
  public static iotHubPivot_noEndpoints = 'iotHubPivot_noEndpoints';
  public static iotHubPivot_Endpoint = 'iotHubPivot_Endpoint';
  public static iotHubPivot_IOTEvents = 'iotHubPivot_IOTEvents';
  public static iotHubPivot_IOTMonitoring = 'iotHubPivot_IOTMonitoring';
  public static customPivot_key = 'customPivot_key';
  public static customPivot_value = 'customPivot_value';
  public static serviceBusCallout_newServiceBusConnection = 'serviceBusCallout_newServiceBusConnection';
  public static serviceBusCallout_serviceBus = 'serviceBusCallout_serviceBus';
  public static resourceCallout_newCustomAppSetting = 'resourceCallout_newCustomAppSetting';
  public static resourceCallout_customAppSetting = 'resourceCallout_customAppSetting';
  public static serviceBusPicker_noNamespaces = 'serviceBusPicker_noNamespaces';
  public static serviceBusPicker_noPolicies = 'serviceBusPicker_noPolicies';
  public static serviceBusPicker_namespace = 'serviceBusPicker_namespace';
  public static serviceBusPicker_policy = 'serviceBusPicker_policy';
  public static documentDBCallout_newDocumentDBConnection = 'documentDBCallout_newDocumentDBConnection';
  public static documentDBCallout_azureCosmosDBAccount = 'documentDBCallout_azureCosmosDBAccount';
  public static documentDBPivot_noDatabaseAccounts = 'documentDBPivot_noDatabaseAccounts';
  public static documentDBPivot_databaseAccount = 'documentDBPivot_databaseAccount';
  public static storageAccountCallout_existingStorageAccount = 'storageAccountCallout_existingStorageAccount';
  public static storageAccountCallout_newStorageAccountConnection = 'storageAccountCallout_newStorageAccountConnection';
  public static storageAccountPivot_noStorageAccounts = 'storageAccountPivot_noStorageAccounts';
  public static storageAccountPivot_storageAccount = 'storageAccountPivot_storageAccount';
  public static newPivot_name = 'newPivot_name';
  public static integrateAddOutput = 'integrateAddOutput';
  public static integrateCreateOutput = 'integrateCreateOutput';
  public static deleteBindingNotification = 'deleteBindingNotification';
  public static deleteBindingNotificationDetails = 'deleteBindingNotificationDetails';
  public static deleteBindingNotificationFailed = 'deleteBindingNotificationFailed';
  public static deleteBindingNotificationSuccess = 'deleteBindingNotificationSuccess';
  public static createFunctionNotification = 'createFunctionNotification';
  public static createFunctionNotificationDetails = 'createFunctionNotificationDetails';
  public static createFunctionNotificationFailed = 'createFunctionNotificationFailed';
  public static createFunctionNotificationFailedDetails = 'createFunctionNotificationFailedDetails';
  public static createFunctionNotificationSuccess = 'createFunctionNotificationSuccess';
  public static readonlyBlobStorageWarning = 'readonlyBlobStorageWarning';
  public static BYOSDeploymentSettingsWarning = 'BYOSDeploymentSettingsWarning';
  public static BYOSNFSShareInfo = 'BYOSNFSShareInfo';
  public static quickstartHeader = 'quickstartHeader';
  public static quickstartDesc = 'quickstartDesc';
  public static viewDocumentation = 'viewDocumentation';
  public static chooseDevelopmentEnv = 'chooseDevelopmentEnv';
  public static quickstartLoadFailure = 'quickstartLoadFailure';
  public static githubActionInfo = 'githubActionInfo';
  public static commitId = 'commitId';
  public static planType = 'planType';
  public static consumptionPlan = 'consumptionPlan';
  public static functionPremiumPlan = 'functionPremiumPlan';
  public static readWritePermissionsRequired = 'readWritePermissionsRequired';
  public static functionsRuntimeVersionCustomInfo = 'functionsRuntimeVersionCustomInfo';
  public static functionsRuntimeVersionExistingFunctionsWarning = 'functionsRuntimeVersionExistingFunctionsWarning';
  public static functionsRuntimeVersionExistingFunctionsConfirmationTitle = 'functionsRuntimeVersionExistingFunctionsConfirmationTitle';
  public static functionsRuntimeVersionExistingFunctionsConfirmationMessage = 'functionsRuntimeVersionExistingFunctionsConfirmationMessage';
  public static githubActionWorkflowScopeMissing = 'githubActionWorkflowScopeMissing';
  public static githubActionWorkflowFileExists = 'githubActionWorkflowFileExists';
  public static remoteDebuggingVSVersionNotSupported = 'remoteDebuggingVSVersionNotSupported';
  public static functionCreate_selectTemplate = 'functionCreate_selectTemplate';
  public static functionTestInput = 'functionTestInput';
  public static functionTestOutput = 'functionTestOutput';
  public static functionTestInputDescriptionForHttp = 'functionTestInputDescriptionForHttp';
  public static httpRun_responseContent = 'httpRun_responseContent';
  public static httpRun_responseCode = 'httpRun_responseCode';
  public static editor_changeFileConfirmMessage = 'editor_changeFileConfirmMessage';
  public static editor_changeFile = 'editor_changeFile';
  public static defaultDocumentsInfoMessage = 'defaultDocumentsInfoMessage';
  public static errorPagesInfoMessage = 'errorPagesInfoMessage';
  public static errorPagesEditMessage = 'errorPagesEditMessage';
  public static validField_validationMessage = 'validField_validationMessage';
  public static maximize = 'maximize';
  public static minimize = 'minimize';
  public static connect = 'connect';
  public static endOfLifeTagTemplate = 'endOfLifeTagTemplate';
  public static functionEditor_appInsightsNotConfigured = 'functionEditor_appInsightsNotConfigured';
  public static functionEditor_connectingToAppInsights = 'functionEditor_connectingToAppInsights';
  public static runtimeStack = 'runtimeStack';
  public static runtimeStackVersion = 'runtimeStackVersion';
  public static functionCreate_extensionBundlesRequired = 'functionCreate_extensionBundlesRequired';
  public static remoteDebuggingNotAvailableOnFlexStamp = 'remoteDebuggingNotAvailableOnFlexStamp';
  public static classicDeprecation = 'classicDeprecation';
  public static saveAppSettingsTitle = 'saveAppSettingsTitle';
  public static saveAppSettingsMessage = 'saveAppSettingsMessage';
  public static azureFunctionsV1Linux = 'azureFunctionsV1Linux';
  public static githubActionStackNotSupportedMessage = 'githubActionStackNotSupportedMessage';
  public static githubActionStackMismatchMessage = 'githubActionStackMismatchMessage';
  public static hostConfigurationLabel = 'hostConfigurationLabel';
  public static destinationPlanPlaceholder = 'destinationPlanPlaceholder';
  public static configureHostJson = 'configureHostJson';
  public static pricing_pv2FlexStampInfoMessage = 'pricing_pv2FlexStampInfoMessage';
  public static pricing_pv2FlexStampCheckboxLabel = 'pricing_pv2FlexStampCheckboxLabel';
  public static pricing_skuCheckWarning = 'pricing_skuCheckWarning';
  public static premiumToConsumptionWarning = 'premiumToConsumptionWarning';
  public static premiumAndConsumptionLinuxInfoMessage = 'premiumAndConsumptionLinuxInfoMessage';
  public static githubActionWorkflowOption = 'githubActionWorkflowOption';
  public static githubActionWorkflowOptionOverwrite = 'githubActionWorkflowOptionOverwrite';
  public static githubActionWorkflowOptionUseExisting = 'githubActionWorkflowOptionUseExisting';
  public static githubActionWorkflowOptionUseExistingMessage = 'githubActionWorkflowOptionUseExistingMessage';
  public static githubActionWorkflowOptionOverwriteMessage = 'githubActionWorkflowOptionOverwriteMessage';
  public static githubActionWorkflowFileLabel = 'githubActionWorkflowFileLabel';
  public static githubActionWorkflowFilePreserveLabel = 'githubActionWorkflowFilePreserveLabel';
  public static githubActionWorkflowFilePreserveDescription = 'githubActionWorkflowFilePreserveDescription';
  public static githubActionWorkflowFileDeleteLabel = 'githubActionWorkflowFileDeleteLabel';
  public static githubActionWorkflowFileDeleteDescription = 'githubActionWorkflowFileDeleteDescription';
  public static githubActionWorkflowFileDeletePanelDescription = 'githubActionWorkflowFileDeletePanelDescription';
  public static githubActionWorkflowFileDeletePanelNoChoiceDescription = 'githubActionWorkflowFileDeletePanelNoChoiceDescription';
  public static githubActionWorkflowFileDeletePanelChoiceDescription = 'githubActionWorkflowFileDeletePanelChoiceDescription';
  public static emptyFunctionKeys = 'emptyFunctionKeys';
  public static featureNotSupportedForPremium = 'featureNotSupportedForPremium';
  public static deleteFunctionKeyNotification = 'deleteFunctionKeyNotification';
  public static deleteFunctionKeyNotificationDetails = 'deleteFunctionKeyNotificationDetails';
  public static deleteFunctionKeyNotificationFailed = 'deleteFunctionKeyNotificationFailed';
  public static deleteFunctionKeyNotificationSuccess = 'deleteFunctionKeyNotificationSuccess';
  public static disableFunctionTestTooltip = 'disableFunctionTestTooltip';
  public static gitHubActionWorkflowFileNameTitle = 'gitHubActionWorkflowFileNameTitle';
  public static noAppFilesWhileFunctionAppStopped = 'noAppFilesWhileFunctionAppStopped';
  public static noAppKeysWhileFunctionAppStopped = 'noAppKeysWhileFunctionAppStopped';
  public static functionIntegrateRefreshAriaLabel = 'functionIntegrateRefreshAriaLabel';
  public static gitHubProtectedBranchSelected = 'gitHubProtectedBranchSelected';
  public static noRuntimeVersionWhileFunctionAppStopped = 'noRuntimeVersionWhileFunctionAppStopped';
  public static githubActionWorkflowsExist = 'githubActionWorkflowsExist';
  public static githubActionWorkflowOptionUseExistingMessageWithoutPreview = 'githubActionWorkflowOptionUseExistingMessageWithoutPreview';
  public static githubActionWorkflowOptionOverwriteIfConfigExists = 'githubActionWorkflowOptionOverwriteIfConfigExists';
  public static appFilesSaveAriaLabel = 'appFilesSaveAriaLabel';
  public static functionEditorRefreshAriaLabel = 'functionEditorRefreshAriaLabel';
  public static integrateDeleteTriggerConfirmHeader = 'integrateDeleteTriggerConfirmHeader';
  public static integrateDeleteTriggerConfirmMessage = 'integrateDeleteTriggerConfirmMessage';
  public static integrateDeleteOutputConfirmHeader = 'integrateDeleteOutputConfirmHeader';
  public static integrateDeleteOutputConfirmMessage = 'integrateDeleteOutputConfirmMessage';
  public static integrateDeleteInputConfirmHeader = 'integrateDeleteInputConfirmHeader';
  public static integrateDeleteInputConfirmMessage = 'integrateDeleteInputConfirmMessage';
  public static integrate_bindingsFailedLoading = 'integrate_bindingsFailedLoading';
  public static integrate_compiledDoNotShowInputOutput = 'integrate_compiledDoNotShowInputOutput';
  public static deleteFunctionKeyHeader = 'deleteFunctionKeyHeader';
  public static deleteFunctionKeyMessage = 'deleteFunctionKeyMessage';
  public static fetchFileContentFailureMessage = 'fetchFileContentFailureMessage';
  public static resourceDropdown_missingAppSetting = 'resourceDropdown_missingAppSetting';
  public static resourceDropdown_noAppSettingsFound = 'resourceDropdown_noAppSettingsFound';
  public static integrate_bindingsMissingDirection = 'integrate_bindingsMissingDirection';
  public static integrate_readOnlyNewProgrammingModel = 'integrate_readOnlyNewProgrammingModel';
  public static functionMonitor_invocations = 'functionMonitor_invocations';
  public static functionMonitor_logs = 'functionMonitor_logs';
  public static logStreaming_openInLiveMetrics = 'logStreaming_openInLiveMetrics';
  public static httpMethod_tooltip = 'httpMethod_tooltip';
  public static xFunctionsKey_validationMessage = 'xFunctionsKey_validationMessage';
  public static filterInvocations = 'filterInvocations';
  public static runQueryInApplicationInsights = 'runQueryInApplicationInsights';
  public static timestamp = 'timestamp';
  public static message = 'message';
  public static successCount = 'successCount';
  public static errorCount = 'errorCount';
  public static last30Days = 'last30Days';
  public static discardChangesTitle = 'discardChangesTitle';
  public static discardChangesMesssage = 'discardChangesMesssage';
  public static information = 'information';
  public static verbose = 'verbose';
  public static githubActionDisconnectConfirmation = 'githubActionDisconnectConfirmation';
  public static githubActionDisconnectDeleteWorkflow = 'githubActionDisconnectDeleteWorkflow';
  public static githubActionDisconnectButton = 'githubActionDisconnectButton';
  public static githubActionCancelDisconnectButton = 'githubActionCancelDisconnectButton';
  public static githubActionWorkflowDeleteCommitMessage = 'githubActionWorkflowDeleteCommitMessage';
  public static githubActionDashboardRepositoryMissingError = 'githubActionDashboardRepositoryMissingError';
  public static githubActionDashboardBranchMissingError = 'githubActionDashboardBranchMissingError';
  public static githubActionDisconnectConfirmationTitle = 'githubActionDisconnectConfirmationTitle';
  public static kuduDisconnectConfirmationTitle = 'kuduDisconnectConfirmationTitle';
  public static vstsDisconnectConfirmationTitle = 'vstsDisconnectConfirmationTitle';
  public static vstsDisconnectConfirmationDescription = 'vstsDisconnectConfirmationDescription';
  public static deploymentCenterGitHubDisconnectLoadingAriaValue = 'deploymentCenterGitHubDisconnectLoadingAriaValue';
  public static deploymentCenterGitHubDisconnectLoading = 'deploymentCenterGitHubDisconnectLoading';
  public static githubActionDisconnectWorkflowDeleteFailed = 'githubActionDisconnectWorkflowDeleteFailed';
  public static disconnectingDeploymentFailWorkflowFileDeleteSucceeded = 'disconnectingDeploymentFailWorkflowFileDeleteSucceeded';
  public static disconnectingDeploymentFailWorkflowFileDeleteSucceededWithMessage =
    'disconnectingDeploymentFailWorkflowFileDeleteSucceededWithMessage';
  public static functionLog_rbacPermissionsForAppInsights = 'functionLog_rbacPermissionsForAppInsights';
  public static deploymentCenterCommandBarAriaLabel = 'deploymentCenterCommandBarAriaLabel';
  public static deploymentCenterSaveCommandAriaLabel = 'deploymentCenterSaveCommandAriaLabel';
  public static deploymentCenterDiscardCommandAriaLabel = 'deploymentCenterDiscardCommandAriaLabel';
  public static deploymentCenterBrowseCommandAriaLabel = 'deploymentCenterBrowseCommandAriaLabel';
  public static deploymentCenterDownloadCommandAriaLabel = 'deploymentCenterDownloadCommandAriaLabel';
  public static deploymentCenterPublishProfileCommandAriaLabel = 'deploymentCenterPublishProfileCommandAriaLabel';
  public static deploymentCenterRefreshCommandAriaLabel = 'deploymentCenterRefreshCommandAriaLabel';
  public static deploymentCenterSyncCommandAriaLabel = 'deploymentCenterSyncCommandAriaLabel';
  public static deploymentCenterSync = 'deploymentCenterSync';
  public static deploymentCenterErrorFetchingInfo = 'deploymentCenterErrorFetchingInfo';
  public static deploymentCenterSettingsConfiguredViewUserNotAuthorized = 'deploymentCenterSettingsConfiguredViewUserNotAuthorized';
  public static deploymentCenterVstsInfoMessage = 'deploymentCenterVstsInfoMessage';
  public static azureDevOpsPortal = 'azureDevOpsPortal';
  public static deploymentCenterVstsInfoMessagePart2 = 'deploymentCenterVstsInfoMessagePart2';
  public static deploymentCenterTfsVsoInfoMessage = 'deploymentCenterTfsVsoInfoMessage';
  public static deploymentCenterDeleteCommandAriaLabel = 'deploymentCenterDeleteCommandAriaLabel';
  public static deploymentCenterDeleteLogsConfirmationTitle = 'deploymentCenterDeleteLogsConfirmationTitle';
  public static deploymentCenterDeleteLogsConfirmationDescription = 'deploymentCenterDeleteLogsConfirmationDescription';
  public static deploymentCenterDeleteLogsNotificationTitle = 'deploymentCenterDeleteLogsNotificationTitle';
  public static deploymentCenterDeleteLogsNotificationDescription = 'deploymentCenterDeleteLogsNotificationDescription';
  public static deploymentCenterDeleteLogsSuccessNotificationDescription = 'deploymentCenterDeleteLogsSuccessNotificationDescription';
  public static deploymentCenterDeleteLogsFailureNotificationDescription = 'deploymentCenterDeleteLogsFailureNotificationDescription';
  public static deploymentCenterDeleteLogsFailureWithErrorNotificationDescription =
    'deploymentCenterDeleteLogsFailureWithErrorNotificationDescription';
  public static managePublishProfile = 'managePublishProfile';
  public static managePublishProfileBasicAuthDisabled = 'managePublishProfileBasicAuthDisabled';
  public static ibizafication_readOnlyPython = 'ibizafication_readOnlyPython';
  public static ibizafication_readOnlyJava = 'ibizafication_readOnlyJava';
  public static ibizafication_readOnlyLocalCache = 'ibizafication_readOnlyLocalCache';
  public static ibizafication_readOnlySourceControlled = 'ibizafication_readOnlySourceControlled';
  public static ibizafication_readOnlySlots = 'ibizafication_readOnlySlots';
  public static ibizafication_readOnlyVSGenerated = 'ibizafication_readOnlyVSGenerated';
  public static ibizafication_readOnly = 'ibizafication_readOnly';
  public static connected = 'connected';
  public static blaclistFile_message = 'blaclistFile_message';
  public static staticSite_emptyApplicationSettingList = 'staticSite_emptyApplicationSettingList';
  public static staticSite_addNewApplicationSetting = 'staticSite_addNewApplicationSetting';
  public static staticSite_ariaLabel_addNewApplicationSetting = 'staticSite_ariaLabel_addNewApplicationSetting';
  public static staticSite_applicationSettings = 'staticSite_applicationSettings';
  public static staticSite_applicationSettingsInfoMessage = 'staticSite_applicationSettingsInfoMessage';
  public static staticSite_environment = 'staticSite_environment';
  public static staticSite_environmentDropdownAriaLabel = 'staticSite_environmentDropdownAriaLabel';
  public static staticSite_filterApplicationSetting = 'staticSite_filterApplicationSetting';
  public static staticSite_discardChangesMesssage = 'staticSite_discardChangesMesssage';
  public static staticSite_changeEnvironmentTitle = 'staticSite_changeEnvironmentTitle';
  public static staticSite_changeEnvironmentMessage = 'staticSite_changeEnvironmentMessage';
  public static staticSite_applicationSettingPropIsRequired = 'staticSite_applicationSettingPropIsRequired';
  public static staticSite_applicationSettingNamesUnique = 'staticSite_applicationSettingNamesUnique';
  public static staticSite_applicationSettingValuesMustBeAnArray = 'staticSite_applicationSettingValuesMustBeAnArray';
  public static staticSite_applicationSettingInvalidProperty = 'staticSite_applicationSettingInvalidProperty';
  public static staticSite_applicationSettingValueMustBeAString = 'staticSite_applicationSettingValueMustBeAString';
  public static staticSite_readOnlyRbac = 'staticSite_readOnlyRbac';
  public static staticSite_stagingEnvironments = 'staticSite_stagingEnvironments';
  public static staticSite_stagingEnvironmentsDescription = 'staticSite_stagingEnvironmentsDescription';
  public static staticSite_enableStagingEnvironments = 'staticSite_enableStagingEnvironments';
  public static deploymentCenterPivotItemLogsHeaderText = 'deploymentCenterPivotItemLogsHeaderText';
  public static deploymentCenterPivotItemContainerLogsHeaderText = 'deploymentCenterPivotItemContainerLogsHeaderText';
  public static deploymentCenterPivotItemBuildLogsHeaderText = 'deploymentCenterPivotItemBuildLogsHeaderText';
  public static deploymentCenterPivotItemLogsAriaLabel = 'deploymentCenterPivotItemLogsAriaLabel';
  public static deploymentCenterPivotItemContainerLogsAriaLabel = 'deploymentCenterPivotItemContainerLogsAriaLabel';
  public static deploymentCenterPivotItemBuildLogsAriaLabel = 'deploymentCenterPivotItemBuildLogsAriaLabel';
  public static deploymentCenterPivotItemSettingsHeaderText = 'deploymentCenterPivotItemSettingsHeaderText';
  public static deploymentCenterPivotItemSettingsAriaLabel = 'deploymentCenterPivotItemSettingsAriaLabel';
  public static deploymentCenterPivotItemFtpsHeaderText = 'deploymentCenterPivotItemFtpsHeaderText';
  public static deploymentCenterPivotItemFtpsAriaLabel = 'deploymentCenterPivotItemFtpsAriaLabel';
  public static deploymentCenterPivotItemGitFtpsHeaderText = 'deploymentCenterPivotItemGitFtpsHeaderText';
  public static deploymentCenterPivotItemGitFtpsAriaLabel = 'deploymentCenterPivotItemGitFtpsAriaLabel';
  public static deploymentCenterContainerLogsLoadingAriaValue = 'deploymentCenterContainerLogsLoadingAriaValue';
  public static deploymentCenterContainerLogsLoading = 'deploymentCenterContainerLogsLoading';
  public static deploymentCenterContainerLogsDesc = 'deploymentCenterContainerLogsDesc';
  public static deploymentCenterContainerLogsFailed = 'deploymentCenterContainerLogsFailed';
  public static deploymentCenterContainerLogsFailedWithError = 'deploymentCenterContainerLogsFailedWithError';
  public static invocationTracesTableTitle = 'invocationTracesTableTitle';
  public static invocationTracesTableDescription = 'invocationTracesTableDescription';
  public static staticSite_refreshConfirmTitle = 'staticSite_refreshConfirmTitle';
  public static staticSite_refreshConfirmMessage = 'staticSite_refreshConfirmMessage';
  public static deploymentCenterRefreshConfirmTitle = 'deploymentCenterRefreshConfirmTitle';
  public static deploymentCenterRedeployConfirmTitle = 'deploymentCenterRedeployConfirmTitle';
  public static deploymentCenterRedeployConfirmMessage = 'deploymentCenterRedeployConfirmMessage';
  public static deploymentCenterCancelWorkflowRunConfirmTitle = 'deploymentCenterCancelWorkflowRunConfirmTitle';
  public static deploymentCenterCancelWorkflowRunConfirmMessage = 'deploymentCenterCancelWorkflowRunConfirmMessage';
  public static deploymentCenterDiscardConfirmTitle = 'deploymentCenterDiscardConfirmTitle';
  public static deploymentCenterDataLossMessage = 'deploymentCenterDataLossMessage';
  public static staticSite_addApplicationSettingHeader = 'staticSite_addApplicationSettingHeader';
  public static staticSite_editApplicationSettingHeader = 'staticSite_editApplicationSettingHeader';
  public static deploymentCenterFtpsDescription = 'deploymentCenterFtpsDescription';
  public static deploymentCenterFtpsEndpointLabel = 'deploymentCenterFtpsEndpointLabel';
  public static deploymentCenterFtpsApplicationScopeTitle = 'deploymentCenterFtpsApplicationScopeTitle';
  public static deploymentCenterFtpsApplicationScopeDescription = 'deploymentCenterFtpsApplicationScopeDescription';
  public static deploymentCenterFtpsUserScopeTitle = 'deploymentCenterFtpsUserScopeTitle';
  public static deploymentCenterFtpsUserScopeDescription = 'deploymentCenterFtpsUserScopeDescription';
  public static deploymentCenterFtpsUserScopeSampleUsername = 'deploymentCenterFtpsUserScopeSampleUsername';
  public static deploymentCenterUserScopeUsernameLabel = 'deploymentCenterUserScopeUsernameLabel';
  public static deploymentCenterFtpsUsernameLabel = 'deploymentCenterFtpsUsernameLabel';
  public static deploymentCenterLocalGitUsernameLabel = 'deploymentCenterLocalGitUsernameLabel';
  public static deploymentCenterFtpsPasswordLabel = 'deploymentCenterFtpsPasswordLabel';
  public static deploymentCenterFtpsConfirmPasswordLabel = 'deploymentCenterFtpsConfirmPasswordLabel';
  public static deploymentCenterFtpsWritePermissionRequired = 'deploymentCenterFtpsWritePermissionRequired';
  public static deploymentCenterFtpsPermissionWarning = 'deploymentCenterFtpsPermissionWarning';
  public static deploymentCenterPublishingUserLoadingMessage = 'deploymentCenterPublishingUserLoadingMessage';
  public static deploymentCenterPublishingUserLoadingAriaLabel = 'deploymentCenterPublishingUserLoadingAriaLabel';
  public static publishingUserFetchFailedMessage = 'publishingUserFetchFailedMessage';
  public static appKeys_hostKeys_description = 'appKeys_hostKeys_description';
  public static appKeys_systemKeys_description = 'appKeys_systemKeys_description';
  public static functionKeys_description = 'functionKeys_description';
  public static reset = 'reset';
  public static resetPublishProfileAriaLabel = 'resetPublishProfileAriaLabel';
  public static showApplicationPasswordAriaLabel = 'showApplicationPasswordAriaLabel';
  public static hideApplicationPasswordAriaLabel = 'hideApplicationPasswordAriaLabel';
  public static showProviderPasswordAriaLabel = 'showProviderPasswordAriaLabel';
  public static hideProviderPasswordAriaLabel = 'hideProviderPasswordAriaLabel';
  public static showProviderConfirmPasswordAriaLabel = 'showProviderConfirmPasswordAriaLabel';
  public static hideProviderConfirmPasswordAriaLabel = 'hideProviderConfirmPasswordAriaLabel';
  public static resetPublishProfileConfirmationTitle = 'resetPublishProfileConfirmationTitle';
  public static resetPublishProfileConfirmationDescription = 'resetPublishProfileConfirmationDescription';
  public static usernameLengthRequirements = 'usernameLengthRequirements';
  public static deploymentCenterFieldRequiredMessage = 'deploymentCenterFieldRequiredMessage';
  public static deploymentCenterFieldPrivateSSHMessage = 'deploymentCenterFieldPrivateSSHMessage';
  public static deploymentCenterExternalRepoMessage = 'deploymentCenterExternalRepoMessage';
  public static deploymentCenterContainerSettingsDescription = 'deploymentCenterContainerSettingsDescription';
  public static deploymentCenterCodeSettingsDescription = 'deploymentCenterCodeSettingsDescription';
  public static deploymentCenterSettingsSourceLabel = 'deploymentCenterSettingsSourceLabel';
  public static deploymentCenterCodeSettingsSourcePlaceholder = 'deploymentCenterCodeSettingsSourcePlaceholder';
  public static deploymentCenterSettingsBuildTitle = 'deploymentCenterSettingsBuildTitle';
  public static deploymentCenterSettingsBuildLabel = 'deploymentCenterSettingsBuildLabel';
  public static deploymentCenterSettingsRuntimeLabel = 'deploymentCenterSettingsRuntimeLabel';
  public static deploymentCenterSettingsRuntimeVersionLabel = 'deploymentCenterSettingsRuntimeVersionLabel';
  public static deploymentCenterConfigureRuntimeMessage = 'deploymentCenterConfigureRuntimeMessage';
  public static deploymentCenterConfigureRuntimeLink = 'deploymentCenterConfigureRuntimeLink';
  public static deploymentCenterImageAndTagError = 'deploymentCenterImageAndTagError';
  public static deploymentCenterContainerSettingsSourceOptionContainerRegistry =
    'deploymentCenterContainerSettingsSourceOptionContainerRegistry';
  public static deploymentCenterContainerSettingsSourceOptionContainerRegistryDescription =
    'deploymentCenterContainerSettingsSourceOptionContainerRegistryDescription';
  public static deploymentCenterContainerSettingsSourceOptionGitHubActions = 'deploymentCenterContainerSettingsSourceOptionGitHubActions';
  public static deploymentCenterContainerSettingsSourceOptionGitHubActionsDescription =
    'deploymentCenterContainerSettingsSourceOptionGitHubActionsDescription';
  public static deploymentCenterGitHubActionsCancelRunMessage = 'deploymentCenterGitHubActionsCancelRunMessage';
  public static deploymentCenterLogSource = 'deploymentCenterLogSource';
  public static deploymentCenterBuildDeployLogSource = 'deploymentCenterBuildDeployLogSource';
  public static deploymentCenterAppLogSource = 'deploymentCenterAppLogSource';
  public static GitHubActionsRunCancelled = 'GitHubActionsRunCancelled';
  public static GitHubActionsRunSkipped = 'GitHubActionsRunSkipped';
  public static GitHubActionsRunTimedOut = 'GitHubActionsRunTimedOut';
  public static GitHubActionsRunActionRequired = 'GitHubActionsRunActionRequired';
  public static functionEditor_privateLinkRunMessage = 'functionEditor_privateLinkRunMessage';
  public static deploymentCenterContainerGitHubActionsTitle = 'deploymentCenterContainerGitHubActionsTitle';
  public static deploymentCenterCodeGitHubTitle = 'deploymentCenterCodeGitHubTitle';
  public static deploymentCenterCodeBitbucketTitle = 'deploymentCenterCodeBitbucketTitle';
  public static deploymentCenterCodeLocalGitTitle = 'deploymentCenterCodeLocalGitTitle';
  public static deploymentCenterCodeOneDriveTitle = 'deploymentCenterCodeOneDriveTitle';
  public static deploymentCenterCodeDropboxTitle = 'deploymentCenterCodeDropboxTitle';
  public static deploymentCenterCodeAzureReposTitle = 'deploymentCenterCodeAzureReposTitle';
  public static deploymentCenterCodeFolder = 'deploymentCenterCodeFolder';
  public static deploymentCenterCodeFolderPlaceholder = 'deploymentCenterCodeFolderPlaceholder';
  public static deploymentCenterCodeExternalGitTitle = 'deploymentCenterCodeExternalGitTitle';
  public static deploymentCenterCodeExternalUsernameLabel = 'deploymentCenterCodeExternalUsernameLabel';
  public static deploymentCenterCodeExternalPasswordLabel = 'deploymentCenterCodeExternalPasswordLabel';
  public static deploymentCenterCodeExternalRepositoryTypeLabel = 'deploymentCenterCodeExternalRepositoryTypeLabel';
  public static deploymentCenterCodeExternalRepositoryPlaceholder = 'deploymentCenterCodeExternalRepositoryPlaceholder';
  public static deploymentCenterCodeExternalBranchPlaceholder = 'deploymentCenterCodeExternalBranchPlaceholder';
  public static deploymentCenterCodeExternalPrivateRepositoryOption = 'deploymentCenterCodeExternalPrivateRepositoryOption';
  public static deploymentCenterCodeExternalPublicRepositoryOption = 'deploymentCenterCodeExternalPublicRepositoryOption';
  public static deploymentCenterCodeLocalGitDesc = 'deploymentCenterCodeLocalGitDesc';
  public static deploymentCenterCodeLocalGitRepositorySetupMessage = 'deploymentCenterCodeLocalGitRepositorySetupMessage';
  public static deploymentCenterCodeLocalGitBranchSetupMessage = 'deploymentCenterCodeLocalGitBranchSetupMessage';
  public static deploymentCenterCodeLocalGitCloneUri = 'deploymentCenterCodeLocalGitCloneUri';
  public static deploymentCenterCodeLocalGitFetchCloneUriError = 'deploymentCenterCodeLocalGitFetchCloneUriError';
  public static deploymentCenterCodeRedeployRequestSubmitted = 'deploymentCenterCodeRedeployRequestSubmitted';
  public static deploymentCenterCodeRedeployRequestSubmittedDesc = 'deploymentCenterCodeRedeployRequestSubmittedDesc';
  public static deploymentCenterCodeRedeploySuccess = 'deploymentCenterCodeRedeploySuccess';
  public static deploymentCenterCodeRedeployFailWithStatusMessage = 'deploymentCenterCodeRedeployFailWithStatusMessage';
  public static deploymentCenterCodeRedeployFail = 'deploymentCenterCodeRedeployFail';
  public static deploymentCenterContainerRegistrySettingsTitle = 'deploymentCenterContainerRegistrySettingsTitle';
  public static deploymentCenterContainerRegistryOptionsLabel = 'deploymentCenterContainerRegistryOptionsLabel';
  public static deploymentCenterContainerRegistrySourceLabel = 'deploymentCenterContainerRegistrySourceLabel';
  public static deploymentCenterPublishProfileDescription = 'deploymentCenterPublishProfileDescription';
  public static downloadPublishProfile = 'downloadPublishProfile';
  public static managePublishProfileCommandBarAriaLabel = 'managePublishProfileCommandBarAriaLabel';
  public static downloadingPublishProfile = 'downloadingPublishProfile';
  public static downloadingPublishProfileFailed = 'downloadingPublishProfileFailed';
  public static downloadingPublishProfileSucceeded = 'downloadingPublishProfileSucceeded';
  public static staticSite_configUpdating = 'staticSite_configUpdating';
  public static staticSite_configUpdateSuccess = 'staticSite_configUpdateSuccess';
  public static staticSite_configUpdateFailure = 'staticSite_configUpdateFailure';
  public static clickToShowValue = 'clickToShowValue';
  public static clickToHideValue = 'clickToHideValue';
  public static testAndRun = 'testAndRun';
  public static appInsightsKeyVaultWarningMessage = 'appInsightsKeyVaultWarningMessage';
  public static clickToUpdateSettings = 'clickToUpdateSettings';
  public static deploymentCenterCodeLogsCICDNotConfiguredHeader = 'deploymentCenterCodeLogsCICDNotConfiguredHeader';
  public static deploymentCenterCodeLogsCICDNotConfiguredDescription = 'deploymentCenterCodeLogsCICDNotConfiguredDescription';
  public static deploymentCenterCodeLogsCICDNotConfiguredGoToSettings = 'deploymentCenterCodeLogsCICDNotConfiguredGoToSettings';
  public static deploymentCenterCodeLogsNoDeployments = 'deploymentCenterCodeLogsNoDeployments';
  public static deploymentCenterCodeDeploymentsLoadingAriaValue = 'deploymentCenterCodeDeploymentsLoadingAriaValue';
  public static deploymentCenterCodeDeploymentsLoading = 'deploymentCenterCodeDeploymentsLoading';
  public static deploymentCenterFtpLoadingAriaValue = 'deploymentCenterFtpLoadingAriaValue';
  public static deploymentCenterFtpLoading = 'deploymentCenterFtpLoading';
  public static deploymentCenterCodeDeploymentsFailed = 'deploymentCenterCodeDeploymentsFailed';
  public static deploymentCenterCodeDeploymentsFailedWithError = 'deploymentCenterCodeDeploymentsFailedWithError';
  public static deploymentCenterCodeLogDetailsFailed = 'deploymentCenterCodeLogDetailsFailed';
  public static deploymentCenterCodeLogDetailsFailedWithError = 'deploymentCenterCodeLogDetailsFailedWithError';
  public static deploymentCenterCodeLogActivityFailed = 'deploymentCenterCodeLogActivityFailed';
  public static deploymentCenterCodeLogActivityFailedWithError = 'deploymentCenterCodeLogActivityFailedWithError';
  public static deploymentCenterCodeDeploymentLogActivityLoadingAriaValue = 'deploymentCenterCodeDeploymentLogActivityLoadingAriaValue';
  public static deploymentCenterCodeDeploymentLogActivityLoading = 'deploymentCenterCodeDeploymentLogActivityLoading';
  public static logDetailsHeader = 'logDetailsHeader';
  public static deploymentCenterOAuthFetchingUserInformation = 'deploymentCenterOAuthFetchingUserInformation';
  public static deploymentCenterOAuthAuthorizingUser = 'deploymentCenterOAuthAuthorizingUser';
  public static deploymentCenterOAuthAuthorizeAriaLabel = 'deploymentCenterOAuthAuthorizeAriaLabel';
  public static deploymentCenterOAuthAuthorize = 'deploymentCenterOAuthAuthorize';
  public static deploymentCenterOAuthChangeAccount = 'deploymentCenterOAuthChangeAccount';
  public static deploymentCenterOAuthSingedInAs = 'deploymentCenterOAuthSingedInAs';
  public static deploymentCenterOAuthOrganization = 'deploymentCenterOAuthOrganization';
  public static deploymentCenterOAuthOrganizationPlaceholder = 'deploymentCenterOAuthOrganizationPlaceholder';
  public static deploymentCenterOAuthProject = 'deploymentCenterOAuthProject';
  public static deploymentCenterOAuthProjectPlaceholder = 'deploymentCenterOAuthProjectPlaceholder';
  public static deploymentCenterOAuthRepository = 'deploymentCenterOAuthRepository';
  public static deploymentCenterOAuthGitHubRepositoryPlaceholder = 'deploymentCenterOAuthGitHubRepositoryPlaceholder';
  public static deploymentCenterOAuthRepositoryPlaceholder = 'deploymentCenterOAuthRepositoryPlaceholder';
  public static deploymentCenterOAuthBranch = 'deploymentCenterOAuthBranch';
  public static deploymentCenterOAuthBranchPlaceholder = 'deploymentCenterOAuthBranchPlaceholder';
  public static deploymentCenterCodeSettingsSourcPlaceholder = 'deploymentCenterCodeSettingsSourcPlaceholder';
  public static deploymentCenterCodeSettingsSourceContinuousDeploymentHeader =
    'deploymentCenterCodeSettingsSourceContinuousDeploymentHeader';
  public static deploymentCenterCodeSettingsSourceManualDeploymentHeader = 'deploymentCenterCodeSettingsSourceManualDeploymentHeader';
  public static deploymentCenterCodeSettingsSourceGitHub = 'deploymentCenterCodeSettingsSourceGitHub';
  public static deploymentCenterCodeSettingsSourceAzureRepos = 'deploymentCenterCodeSettingsSourceAzureRepos';
  public static deploymentCenterCodeSettingsSourceBitbucket = 'deploymentCenterCodeSettingsSourceBitbucket';
  public static deploymentCenterCodeSettingsSourceLocalGit = 'deploymentCenterCodeSettingsSourceLocalGit';
  public static deploymentCenterCodeSettingsSourceOneDrive = 'deploymentCenterCodeSettingsSourceOneDrive';
  public static deploymentCenterCodeSettingsSourceDropbox = 'deploymentCenterCodeSettingsSourceDropbox';
  public static deploymentCenterCodeSettingsSourceExternalGit = 'deploymentCenterCodeSettingsSourceExternalGit';
  public static deploymentCenterCodeSettingsBuildGitHubAction = 'deploymentCenterCodeSettingsBuildGitHubAction';
  public static deploymentCenterCodeSettingsBuildKudu = 'deploymentCenterCodeSettingsBuildKudu';
  public static deploymentCenterCodeSettingsBuildVsts = 'deploymentCenterCodeSettingsBuildVsts';
  public static leaveFeedback = 'leaveFeedback';
  public static functionLogsFeedbackCESQuestion = 'functionLogsFeedbackCESQuestion';
  public static functionLogsFeedbackCVAQuestion = 'functionLogsFeedbackCVAQuestion';
  public static deploymentCenterFeedbackCESQuestion = 'deploymentCenterFeedbackCESQuestion';
  public static deploymentCenterFeedbackCVAQuestion = 'deploymentCenterFeedbackCVAQuestion';
  public static deploymentCenterConfigureGitHubPermissionsKudu = 'deploymentCenterConfigureGitHubPermissionsKudu';
  public static deploymentCenterConfigureGitHubPermissionsGHA = 'deploymentCenterConfigureGitHubPermissionsGHA';
  public static deploymentCenterProdSlotWarning = 'deploymentCenterProdSlotWarning';
  public static deploymentCenterOneDriveDropboxWarning = 'deploymentCenterOneDriveDropboxWarning';
  public static deploymentCenterNoWritePermissionsError = 'deploymentCenterNoWritePermissionsError';
  public static deploymentCenterSettingsReadOnlyGitHubNotAuthorized = 'deploymentCenterSettingsReadOnlyGitHubNotAuthorized';
  public static deploymentCenterSettingsWorkflowConfigTitle = 'deploymentCenterSettingsWorkflowConfigTitle';
  public static deploymentCenterSettingsWorkflowConfigPreviewDescription = 'deploymentCenterSettingsWorkflowConfigPreviewDescription';
  public static deploymentCenterSettingsWorkflowConfigPreviewFileButtonText = 'deploymentCenterSettingsWorkflowConfigPreviewFileButtonText';
  public static deploymentCenterSettingsWorkflowConfigPreviewFileDisabledInfo =
    'deploymentCenterSettingsWorkflowConfigPreviewFileDisabledInfo';
  public static deploymentCenterSettingsGitHubActionWorkflowOptionOverwrite = 'deploymentCenterSettingsGitHubActionWorkflowOptionOverwrite';
  public static deploymentCenterSettingsGitHubActionWorkflowOptionAdd = 'deploymentCenterSettingsGitHubActionWorkflowOptionAdd';
  public static deploymentCenterSettingsGitHubActionWorkflowOptionUseExisting =
    'deploymentCenterSettingsGitHubActionWorkflowOptionUseExisting';
  public static deploymentCenterSettingsGitHubActionWorkflowOptionUseAvailable =
    'deploymentCenterSettingsGitHubActionWorkflowOptionUseAvailable';
  public static deploymentCenterSettingsGitHubActionWorkflowOptionPlaceholder =
    'deploymentCenterSettingsGitHubActionWorkflowOptionPlaceholder';
  public static deploymentCenterWorkflowConfigsLoadingAriaValue = 'deploymentCenterWorkflowConfigsLoadingAriaValue';
  public static deploymentCenterWorkflowConfigsLoading = 'deploymentCenterWorkflowConfigsLoading';
  public static deploymentCenterWorkflowConfigsFilePathLabel = 'deploymentCenterWorkflowConfigsFilePathLabel';
  public static deploymentCenterGitHubActionsBuildDescription = 'deploymentCenterGitHubActionsBuildDescription';
  public static deploymentCenterKuduBuildDescription = 'deploymentCenterKuduBuildDescription';
  public static deploymentCenterVstsBuildDescription = 'deploymentCenterVstsBuildDescription';
  public static deploymentCenterVstsBuildMessage = 'deploymentCenterVstsBuildMessage';
  public static deploymentCenterVstsBuildGetStartedMessage = 'deploymentCenterVstsBuildGetStartedMessage';
  public static deploymentCenterVstsDocsMessage = 'deploymentCenterVstsDocsMessage';
  public static deploymentCenterVstsGetStarted = 'deploymentCenterVstsGetStarted';
  public static deploymentCenterChangeBuildText = 'deploymentCenterChangeBuildText';
  public static functionMonitor_orchestrations = 'functionMonitor_orchestrations';
  public static functionMonitor_entities = 'functionMonitor_entities';
  public static functionEditor_appInsightsLogs = 'functionEditor_appInsightsLogs';
  public static functionEditor_fileBasedLogs = 'functionEditor_fileBasedLogs';
  public static functionEditor_fileBasedLogsCalloutMessage = 'functionEditor_fileBasedLogsCalloutMessage';
  public static orchestrationTracesTableTitle = 'orchestrationTracesTableTitle';
  public static orchestrationTracesTableDescription = 'orchestrationTracesTableDescription';
  public static runtimeStatus = 'runtimeStatus';
  public static instanceId = 'instanceId';
  public static filterOrchestrations = 'filterOrchestrations';
  public static entityTracesTableTitle = 'entityTracesTableTitle';
  public static entityTracesTableDescription = 'entityTracesTableDescription';
  public static filterEntities = 'filterEntities';
  public static state = 'state';
  public static orchestrationDetails = 'orchestrationDetails';
  public static failedToFetchRepositories = 'failedToFetchRepositories';
  public static failedToFetchTags = 'failedToFetchTags';
  public static entityDetails = 'entityDetails';
  public static pricing_pv2FlexStampCheckboxAriaLabel = 'pricing_pv2FlexStampCheckboxAriaLabel';
  public static pricing_pv2UpsellInfoMessageAriaLabel = 'pricing_pv2UpsellInfoMessageAriaLabel';
  public static pricing_appDensityWarningMessageAriaLabel = 'pricing_appDensityWarningMessageAriaLabel';
  public static ibizafication_readOnlyLinuxElastic = 'ibizafication_readOnlyLinuxElastic';
  public static stackVersionAutoUpdate = 'stackVersionAutoUpdate';
  public static versionLabel = 'versionLabel';
  public static javaWebServer = 'javaWebServer';
  public static javaWebServerVersion = 'javaWebServerVersion';
  public static ibizafication_readOnlyCustom = 'ibizafication_readOnlyCustom';
  public static selectDevelopmentEnvironment = 'selectDevelopmentEnvironment';
  public static selectDevelopmentEnvironmentDescription = 'selectDevelopmentEnvironmentDescription';
  public static developmentEnvironment = 'developmentEnvironment';
  public static programmingModel = 'programmingModel';
  public static v1ProgrammingModel = 'v1ProgrammingModel';
  public static v2ProgrammingModel = 'v2ProgrammingModel';
  public static selectTemplate = 'selectTemplate';
  public static selectTemplateDescription = 'selectTemplateDescription';
  public static description = 'description';
  public static viewTemplate = 'viewTemplate';
  public static viewTemplateFormat = 'viewTemplateFormat';
  public static templateDetails = 'templateDetails';
  public static detailDescription = 'detailDescription';
  public static developInPortal = 'developInPortal';
  public static storageAccountDetailsFetchFailure = 'storageAccountDetailsFetchFailure';
  public static containerImage = 'containerImage';
  public static containerImagePlaceholder = 'containerImagePlaceholder';
  public static savingContainerConfiguration = 'savingContainerConfiguration';
  public static savingContainerConfigurationSuccess = 'savingContainerConfigurationSuccess';
  public static savingContainerConfigurationFailed = 'savingContainerConfigurationFailed';
  public static savingContainerConfigurationFailedWithStatusMessage = 'savingContainerConfigurationFailedWithStatusMessage';
  public static deploymentCenterServerUrlIsUrl = 'deploymentCenterServerUrlIsUrl';
  public static pricing_pv3NotAvailable = 'pricing_pv3NotAvailable';
  public static hyperVIsolation = 'hyperVIsolation';
  public static hyperVIsolationDesc = 'hyperVIsolationDesc';
  public static pricing_ACU_Pv3 = 'pricing_ACU_Pv3';
  public static pricing_vCores = 'pricing_vCores';
  public static functionInfoFetchError = 'functionInfoFetchError';
  public static functionInfoUnavailableError = 'functionInfoUnavailableError';
  public static createHostKeyNotification = 'createHostKeyNotification';
  public static createSystemKeyNotification = 'createSystemKeyNotification';
  public static createFunctionKeyNotification = 'createFunctionKeyNotification';
  public static createKeyNotificationDetails = 'createKeyNotificationDetails';
  public static createKeyNotificationSuccess = 'createKeyNotificationSuccess';
  public static createKeyNotificationFailed = 'createKeyNotificationFailed';
  public static createKeyNotificationFailedDetails = 'createKeyNotificationFailedDetails';
  public static stackVersionDeprecated = 'stackVersionDeprecated';
  public static stackVersionPreview = 'stackVersionPreview';
  public static workflowRuntimeSettings = 'workflowRuntimeSettings';
  public static uploadingFile = 'uploadingFile';
  public static uploadingFileWithName = 'uploadingFileWithName';
  public static uploadingFileSuccessWithName = 'uploadingFileSuccessWithName';
  public static uploadingFileFailureForSizeWithName = 'uploadingFileFailureForSizeWithName';
  public static uploadingFileFailureForExtWithName = 'uploadingFileFailureForExtWithName';
  public static uploadingFileFailureForUnknownWithName = 'uploadingFileFailureForUnknownWithName';
  public static earlyAccessTemplate = 'earlyAccessTemplate';
  public static pricing_iv2NotAvailable = 'pricing_iv2NotAvailable';
  public static movingFromV2Warning = 'movingFromV2Warning';
  public static deploymentCenterContainerType = 'deploymentCenterContainerType';
  public static deploymentCenterInvalidYaml = 'deploymentCenterInvalidYaml';
  public static deploymentCenterChooseFile = 'deploymentCenterChooseFile';
  public static logStreamingHostStatusError = 'logStreamingHostStatusError';
  public static deploymentCenterCodeDevOpsTitle = 'deploymentCenterCodeDevOpsTitle';
  public static deploymentCenterProject = 'deploymentCenterProject';
  public static deploymentCenterProjectPlaceholder = 'deploymentCenterProjectPlaceholder';
  public static deploymentCenterDevOpsNoAccounts = 'deploymentCenterDevOpsNoAccounts';
  public static appInsightsKeyError = 'appInsightsKeyError';
  public static earlyAccessStackMessage = 'earlyAccessStackMessage';
  public static deprecatedStackMessage = 'deprecatedStackMessage';
  public static endOfLifeStackMessage = 'endOfLifeStackMessage';
  public static netVersionLabel = 'netVersionLabel';
  public static deploymentCenterContainerAcrRegistriesNotAvailable = 'deploymentCenterContainerAcrRegistriesNotAvailable';
  public static deploymentCenterContainerAcrFailedToLoadRegistriesWithError = 'deploymentCenterContainerAcrFailedToLoadRegistriesWithError';
  public static deploymentCenterContainerAcrFailedToLoadRegistries = 'deploymentCenterContainerAcrFailedToLoadRegistries';
  public static deploymentCenterContainerAcrFailedToLoadCredentialsWithError =
    'deploymentCenterContainerAcrFailedToLoadCredentialsWithError';
  public static deploymentCenterContainerAcrFailedToLoadCredentials = 'deploymentCenterContainerAcrFailedToLoadCredentials';
  public static deploymentCenterContainerAcrFailedToLoadImagesWithError = 'deploymentCenterContainerAcrFailedToLoadImagesWithError';
  public static deploymentCenterContainerAcrFailedToLoadImages = 'deploymentCenterContainerAcrFailedToLoadImages';
  public static deploymentCenterContainerAcrFailedToLoadTagsWithError = 'deploymentCenterContainerAcrFailedToLoadTagsWithError';
  public static deploymentCenterContainerAcrFailedToLoadTags = 'deploymentCenterContainerAcrFailedToLoadTags';
  public static moreCommands = 'moreCommands';
  public static deploymentCenterProdSlotWarningLinkAriaLabel = 'deploymentCenterProdSlotWarningLinkAriaLabel';
  public static deploymentCenterOneDriveDropboxLinkAriaLabel = 'deploymentCenterOneDriveDropboxLinkAriaLabel';
  public static deploymentCenterCodeRedeployCommitRequestSubmittedDesc = 'deploymentCenterCodeRedeployCommitRequestSubmittedDesc';
  public static deploymentCenterCodeRedeployCommitSuccess = 'deploymentCenterCodeRedeployCommitSuccess';
  public static deploymentCenterCodeRedeployCommitFailed = 'deploymentCenterCodeRedeployCommitFailed';
  public static deploymentCenterCodeRedeployCommitFailedWithError = 'deploymentCenterCodeRedeployCommitFailedWithError';
  public static deploymentCenterRedeployCommit = 'deploymentCenterRedeployCommit';
  public static resourceConnection = 'resourceConnection';
  public static deploymentCenterSettingsLoadingAriaValue = 'deploymentCenterSettingsLoadingAriaValue';
  public static deploymentCenterSettingsLoading = 'deploymentCenterSettingsLoading';
  public static ibizafication_readOnlyDotnet5 = 'ibizafication_readOnlyDotnet5';
  public static ibizafication_readOnlyArc = 'ibizafication_readOnlyArc';
  public static resourceConnector = 'resourceConnector';
  public static keyVaultReferenceInitializedStatus = 'keyVaultReferenceInitializedStatus';
  public static clickHereToAccessSite = 'clickHereToAccessSite';
  public static pricing_workflowStandardNotAvailable = 'pricing_workflowStandardNotAvailable';
  public static staticSiteStagingEnvironments = 'staticSiteStagingEnvironments';
  public static configurationFeedbackCESQuestion = 'configurationFeedbackCESQuestion';
  public static configurationFeedbackCVAQuestion = 'configurationFeedbackCVAQuestion';
  public static deploymentCenterJavaWebServerStack = 'deploymentCenterJavaWebServerStack';
  public static readOnlyMissingAzureFilesSetting = 'readOnlyMissingAzureFilesSetting';
  public static readOnlyNewNodePreview = 'readOnlyNewNodePreview';
  public static deploymentCenterAccountSignIn = 'deploymentCenterAccountSignIn';
  public static deploymentCenterChangeAccountInfoMessage = 'deploymentCenterChangeAccountInfoMessage';
  public static deploymentCenterChangeAccountInfoButton = 'deploymentCenterChangeAccountInfoButton';
  public static deploymentCenterDeprecatedTokenWarningMessage = 'deploymentCenterDeprecatedTokenWarningMessage';
  public static deploymentCenterDeprecatedTokenDialogTitle = 'deploymentCenterDeprecatedTokenDialogTitle';
  public static deploymentCenterDeprecatedTokenDialogBody = 'deploymentCenterDeprecatedTokenDialogBody';
  public static deploymentCenterUpdateTokenSuccessMessage = 'deploymentCenterUpdateTokenSuccessMessage';
  public static missingWorkflowDispatchTrigger = 'missingWorkflowDispatchTrigger';
  public static deploymentCenterWorkflowError = 'deploymentCenterWorkflowError';
  public static enablePortalEditingForLinuxConsumptionWarning = 'enablePortalEditingForLinuxConsumptionWarning';
  public static validFileShouldBeSelectedWarning = 'validFileShouldBeSelectedWarning';
  public static invalidFileSelectedWarning = 'invalidFileSelectedWarning';
  public static switchToJbossWarningBaner = 'switchToJbossWarningBaner';
  public static jbossClusteringInfo = 'jbossClusteringInfo';
  public static adminCredentials = 'adminCredentials';
  public static managedIdentity = 'managedIdentity';
  public static functionTestInputDescription = 'functionTestInputDescription';
  public static missingCorsMessage = 'missingCorsMessage';
  public static invalidCronExpressionMessage = 'invalidCronExpressionMessage';
  public static systemAssigned = 'systemAssigned';
  public static userAssigned = 'userAssigned';
  public static managedIdentityTypePlaceholder = 'managedIdentityTypePlaceholder';
  public static managedIdentityInfoMessage = 'managedIdentityInfoMessage';
  public static acrCredentialsWarningMessage = 'acrCredentialsWarningMessage';
  public static addIdentity = 'addIdentity';
  public static deploymentCenterAcrComboBoxPlaceholder = 'deploymentCenterAcrComboBoxPlaceholder';
  public static deploymentCenterImageComboBoxPlaceholder = 'deploymentCenterImageComboBoxPlaceholder';
  public static deploymentCenterTagComboBoxPlaceholder = 'deploymentCenterTagComboBoxPlaceholder';
  public static staticSite_generalSettings = 'staticSite_generalSettings';
  public static staticSite_passwordProtection = 'staticSite_passwordProtection';
  public static staticSite_passwordProtectionDescription = 'staticSite_passwordProtectionDescription';
  public static staticSite_passwordProtectionDisabled = 'staticSite_passwordProtectionDisabled';
  public static staticSite_passwordProtectionEnabledStaging = 'staticSite_passwordProtectionEnabledStaging';
  public static staticSite_passwordProtectionEnabledProductionAndStaging = 'staticSite_passwordProtectionEnabledProductionAndStaging';
  public static staticSite_visitorPassword = 'staticSite_visitorPassword';
  public static staticSite_enterVisitorPassword = 'staticSite_enterVisitorPassword';
  public static staticSite_confirmVisitorPassword = 'staticSite_confirmVisitorPassword';
  public static staticSite_visitorPasswordRequired = 'staticSite_visitorPasswordRequired';
  public static staticSite_confirmVisitorPasswordRequired = 'staticSite_confirmVisitorPasswordRequired';
  public static staticSite_configurationFile = 'staticSite_configurationFile';
  public static staticSite_configurationFileDescription = 'staticSite_configurationFileDescription';
  public static staticSite_configurationFileToggle = 'staticSite_configurationFileToggle';
  public static staticSite_generalSettingsUpdate = 'staticSite_generalSettingsUpdate';
  public static staticSite_loadingGeneralSettings = 'staticSite_loadingGeneralSettings';
  public static staticSite_snippets = 'staticSite_snippets';
  public static staticSite_snippetsMax = 'staticSite_snippetsMax';
  public static staticSite_appliesTo = 'staticSite_appliesTo';
  public static staticSite_snippetNoContentError = 'staticSite_snippetNoContentError';
  public static staticSite_snippetContentError = 'staticSite_snippetContentError';
  public static staticSite_snippetNameRequired = 'staticSite_snippetNameRequired';
  public static staticSite_snippetInsertionLocationRequired = 'staticSite_snippetInsertionLocationRequired';
  public static staticSite_snippetLocationRequired = 'staticSite_snippetLocationRequired';
  public static staticSite_snippetEnironmentRequired = 'staticSite_snippetEnironmentRequired';
  public static staticSite_environments = 'staticSite_environments';
  public static staticSite_valueTitle = 'staticSite_valueTitle';
  public static staticSite_typeTitle = 'staticSite_typeTitle';
  public static staticSite_environmentSelectPlaceholder = 'staticSite_environmentSelectPlaceholder';
  public static staticSite_snippetNamePlaceholder = 'staticSite_snippetNamePlaceholder';
  public static staticSite_snippetEnvironmentsErrorMessage = 'staticSite_snippetEnvironmentsErrorMessage';
  public static staticSite_snippetNoEnvironmentsErrorMessage = 'staticSite_snippetNoEnvironmentsErrorMessage';
  public static staticSite_filterSnippets = 'staticSite_filterSnippets';
  public static staticSite_insertionLocation = 'staticSite_insertionLocation';
  public static staticSite_prepend = 'staticSite_prepend';
  public static staticSite_append = 'staticSite_append';
  public static staticSite_deletingSnippet = 'staticSite_deletingSnippet';
  public static staticSite_deletingSnippetSuccess = 'staticSite_deletingSnippetSuccess';
  public static staticSite_deletingSnippetFailure = 'staticSite_deletingSnippetFailure';
  public static staticSite_deletingSnippetFailureWithMessage = 'staticSite_deletingSnippetFailureWithMessage';
  public static staticSite_addingSnippet = 'staticSite_addingSnippet';
  public static staticSite_addingSnippetSuccess = 'staticSite_addingSnippetSuccess';
  public static staticSite_addingSnippetFailure = 'staticSite_addingSnippetFailure';
  public static staticSite_addingSnippetFailureWithMessage = 'staticSite_addingSnippetFailureWithMessage';
  public static staticSite_updatingSnippet = 'staticSite_updatingSnippet';
  public static staticSite_updatingSnippetSuccess = 'staticSite_updatingSnippetSuccess';
  public static staticSite_updatingSnippetFailure = 'staticSite_updatingSnippetFailure';
  public static staticSite_updatingSnippetFailureWithMessage = 'staticSite_updatingSnippetFailureWithMessage';
  public static staticSite_noSnippets = 'staticSite_noSnippets';
  public static staticSite_allEnvironments = 'staticSite_allEnvironments';
  public static staticSite_snippetContentPlaceholder = 'staticSite_snippetContentPlaceholder';
  public static staticSite_selectEnvironments = 'staticSite_selectEnvironments';
  public static staticSite_loadingSnippets = 'staticSite_loadingSnippets';
  public static staticSite_loadingApplicationSettings = 'staticSite_loadingApplicationSettings';
  public static staticSite_generalSettingsUpdateWithSuccess = 'staticSite_generalSettingsUpdateWithSuccess';
  public static staticSite_generalSettingsUpdateWithFailure = 'staticSite_generalSettingsUpdateWithFailure';
  public static staticSite_generalSettingsUpdateWithFailureNoMessage = 'staticSite_generalSettingsUpdateWithFailureNoMessage';
  public static staticSite_head = 'staticSite_head';
  public static staticSite_headerCheckboxAriaLabel = 'staticSite_headerCheckboxAriaLabel';
  public static staticSite_rowCheckboxAriaLabel = 'staticSite_rowCheckboxAriaLabel';
  public static staticSite_deleteSnippetConfirmation = 'staticSite_deleteSnippetConfirmation';
  public static staticSite_deleteSnippetConfirmationTitle = 'staticSite_deleteSnippetConfirmationTitle';
  public static staticSite_body = 'staticSite_body';
  public static staticSite_SnippetsDescription = 'staticSite_SnippetsDescription';
  public static staticSite_passwordProtectionSkuWarning = 'staticSite_passwordProtectionSkuWarning';
  public static functionSupportedRuntimeVersionNotConfiguredMessage = 'functionSupportedRuntimeVersionNotConfiguredMessage';
  public static functionsSupportedRuntimeVersionMissingWarningWithVersionList =
    'functionsSupportedRuntimeVersionMissingWarningWithVersionList';
  public static functionsSupportedRuntimeVersionMissingWarning = 'functionsSupportedRuntimeVersionMissingWarning';
  public static deploymentCenterBitbucketDescriptionText = 'deploymentCenterBitbucketDescriptionText';
  public static deploymentCenterExternalGitDescriptionText = 'deploymentCenterExternalGitDescriptionText';
  public static deploymentCenterAzureReposDescriptionText = 'deploymentCenterAzureReposDescriptionText';
  public static deploymentCenterDropboxDescriptionText = 'deploymentCenterDropboxDescriptionText';
  public static deploymentCenterOneDriveDescriptionText = 'deploymentCenterOneDriveDescriptionText';
  public static disconnecting = 'disconnecting';
  public static connectedAndFilteredMessage = 'connectedAndFilteredMessage';
  public static containerApp_console_chooseStartUpCommand = 'containerApp_console_chooseStartUpCommand';
  public static containerApp_console_failedToConnect = 'containerApp_console_failedToConnect';
  public static containerApp_console_connect = 'containerApp_console_connect';
  public static containerApp_console_custom = 'containerApp_console_custom';
  public static new_parenthesized = 'new_parenthesized';
  public static nodeStackLearnMore = 'nodeStackLearnMore';
  public static containerApp_console_startUpCommandAriaLabel = 'containerApp_console_startUpCommandAriaLabel';
  public static containerApp_console_cancel = 'containerApp_console_cancel';
  public static createFunction_fileContentError = 'createFunction_fileContentError';
  public static createFunction_filePathError = 'createFunction_filePathError';
  public static createFunction_functionAppExistsError = 'createFunction_functionAppExistsError';
  public static createFunction_functionNameError = 'createFunction_functionNameError';
  public static createFunction_functionKindError = 'createFunction_functionKindError';
  public static createFunction_noAppSettingsPermissionsError = 'createFunction_noAppSettingsPermissionsError';
  public static createFunction_noBlueprintFilenameError = 'createFunction_noBlueprintFilenameError';
  public static createFunction_noResourceIdError = 'createFunction_noResourceIdError';
  public static createFunction_noSubstitutionsError = 'createFunction_noSubstitutionsError';
  public static createFunction_selectedTemplateError = 'createFunction_selectedTemplateError';
  public static createFunctionDeploymentNotification = 'createFunctionDeploymentNotification';
  public static createFunctionDeploymentNotificationDetails = 'createFunctionDeploymentNotificationDetails';
  public static createFunctionDeploymentNotificationSuccess = 'createFunctionDeploymentNotificationSuccess';
  public static createFunctionDeploymentNotificationFailed = 'createFunctionDeploymentNotificationFailed';
  public static functionHostKeyDeleteConfirmMessage = 'functionHostKeyDeleteConfirmMessage';
  public static vnetImagePullOptionLabel = 'vnetImagePullOptionLabel';
  public static vnetImagePullLegacyAppSettingInfo = 'vnetImagePullLegacyAppSettingInfo';
  public static unauthorizedMessageFunctionEditor = 'unauthorizedMessageFunctionEditor';
  public static fetchFileContentUnAuthorizedFailureMessage = 'fetchFileContentUnAuthorizedFailureMessage';
  public static ftpsUserScopeCredentialsResetNotifTitle = 'ftpsUserScopeCredentialsResetNotifTitle';
  public static ftpsUserScopeCredentialsResetNotifSuccess = 'ftpsUserScopeCredentialsResetNotifSuccess';
  public static ftpsUserScopeCredentialsResetNotifFailure = 'ftpsUserScopeCredentialsResetNotifFailure';
  public static resetUserScopeCredentialsAriaLabel = 'resetUserScopeCredentialsAriaLabel';
  public static resetUserScopeCredentialsConfirmationTitle = 'resetUserScopeCredentialsConfirmationTitle';
  public static resetUserScopeCredentialsConfirmationDescription = 'resetUserScopeCredentialsConfirmationDescription';
  public static connectionStringInfoMessage = 'connectionStringInfoMessage';
  public static ibizafication_readOnlyDotnetIsolated = 'ibizafication_readOnlyDotnetIsolated';
  public static consoleContainerTextAreaAriaLabel = 'consoleContainerTextAreaAriaLabel';
  public static deploymentCenterScmBasicAuthErrorMessage = 'deploymentCenterScmBasicAuthErrorMessage';
  public static deploymentCenterScmBasicAuthErrorMessageWithOidc = 'deploymentCenterScmBasicAuthErrorMessageWithOidc';
  public static deploymentCenterScmBasicAuthValidationError = 'deploymentCenterScmBasicAuthValidationError';
  public static configureDeploymentCredentialsLinkAriaLabel = 'configureDeploymentCredentialsLinkAriaLabel';
  public static portCountRange = 'portCountRange';
  public static toggleAppSettingSelectionAriaLabel = 'toggleAppSettingSelectionAriaLabel';
  public static selectAppSettingAriaLabel = 'selectAppSettingAriaLabel';
  public static toggleAllAppSettingsAriaLabel = 'toggleAllAppSettingsAriaLabel';
  public static toggleSnippetSelectionAriaLabel = 'toggleSnippetSelectionAriaLabel';
  public static selectSnippetAriaLabel = 'selectSnippetAriaLabel';
  public static toggleAllSnippetsAriaLabel = 'toggleAllSnippetsAriaLabel';
  public static hideButton = 'hideButton';
  public static showButton = 'showButton';
  public static troubleshoot = 'troubleshoot';
  public static authenticationSettingsTitle = 'authenticationSettingsTitle';
  public static authenticationSettingsDescription = 'authenticationSettingsDescription';
  public static authenticationSettingsFederatedIdentity = 'authenticationSettingsFederatedIdentity';
  public static authenticationSettingsUserAssignedManagedIdentity = 'authenticationSettingsUserAssignedManagedIdentity';
  public static authenticationSettingsBasicAuthentication = 'authenticationSettingsBasicAuthentication';
  public static authenticationSettingsPublishProfile = 'authenticationSettingsPublishProfile';
  public static authenticationSettingsAuthenticationType = 'authenticationSettingsAuthenticationType';
  public static authenticationSettingsAuthenticationPlaceholder = 'authenticationSettingsAuthenticationPlaceholder';
  public static authenticationSettingsIdentity = 'authenticationSettingsIdentity';
  public static authenticationSettingsIdentityPlaceholder = 'authenticationSettingsIdentityPlaceholder';
  public static authenticationSettingsSubscriptionPlaceholder = 'authenticationSettingsSubscriptionPlaceholder';
  public static createNewOption = 'createNewOption';
  public static authenticationSettingsOidcPermissionsValidationError = 'authenticationSettingsOidcPermissionsValidationError';
  public static authenticationSettingsIdentityAssignmentPermissionsError = 'authenticationSettingsIdentityAssignmentPermissionsError';
  public static authenticationSettingsIdentityWritePermissionsError = 'authenticationSettingsIdentityWritePermissionsError';
  public static authenticationSettingsIdentityUnsupportedRegionError = 'authenticationSettingsIdentityUnsupportedRegionError';
  public static authenticationSettingsIdentityCreationPrerequisitesLinkAriaLabel =
    'authenticationSettingsIdentityCreationPrerequisitesLinkAriaLabel';
  public static authenticationSettingsRoleAssignmentPrerequisitesLinkAriaLabel =
    'authenticationSettingsRoleAssignmentPrerequisitesLinkAriaLabel';
  public static authenticationSettingsFederatedCredentialsLinkAriaLabel = 'authenticationSettingsFederatedCredentialsLinkAriaLabel';
  public static authenticationSettingsOidcPermissionsLinkAriaLabel = 'authenticationSettingsOidcPermissionsLinkAriaLabel';
  public static sshDisabledInfoBubbleMessage = 'sshDisabledInfoBubbleMessage';
  public static staticSite_appSettingsMoved = 'staticSite_appSettingsMoved';
  public static ftpBasicAuthInfoMessage = 'ftpBasicAuthInfoMessage';
  public static noRuntimeStackFound = 'noRuntimeStackFound';
  public static invalidStack = 'invalidStack';
  public static invalidWindowsNodeStackVersion = 'invalidWindowsNodeStackVersion';
  public static invalidNonWindowsNodeStackVersion = 'invalidNonWindowsNodeStackVersion';
  public static disabledDotNetVersion = 'disabledDotNetVersion';
  public static ipv4 = 'ipv4';
  public static ipv6 = 'ipv6';
  public static ipv4AndIpv6 = 'ipv4AndIpv6';
  public static inboundIpModePreviewLabel = 'inboundIpModePreviewLabel';
  public static externalGitPrivateGitHubNotSupported = 'externalGitPrivateGitHubNotSupported';
  public static externalGitPrivateBitbucketNotSupported = 'externalGitPrivateBitbucketNotSupported';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/portal-resources.ts